const om = {
  // 增
  "version": {
    "to_old": "Versi sebelumnya",
    "to_new": "Versi baru",
    "default_node": "simpul default",
    "default_theme": "Tema standar",
    "custom_theme": "Membuat tema",
  },
  // 增
  "intro": {
    // 铃铛图标内
    "sys_msg": "Pesan sistem",
    "gaa_msg": "Peringatan penggera",
    "new_guide": "Novice guidance",
    // 滑块
    "slider_quite": "Keluar boot",
    "slider_pre": "Depan",
    "slider_next": "Setelah",
    "slider_enter": "Masukkan versi baru",
    // 步骤一(项目管理)
    "step_project_1": "Peralatan manajemen sistem baru",
    "step_project_2": "Newly added",
    "step_project_3": "manajemen proyek",
    "step_project_4": "fungsi, manajemen peralatan per item. Pengguna dapat mengubah proyek",
    "step_project_5": "baru, edit, hapus",
    // 步骤二(显示模式)
    "step_mode_1": "Pilih gaya daftar perangkat favorit Anda",
    "step_mode_2": "Daftar perangkat dapat diakses melalui",
    "step_mode_3": "daftar atau kartu",
    "step_mode_4": "Anda dapat memilih metode presentasi menurut situasi Anda.",
    // 步骤三(点击设备)
    "step_device_1": "Cepat cari perangkat yang menarik",
    "step_device_2": "Newly added",
    "step_device_3": "fokus pada peralatan",
    "step_device_4": "fungsi,",
    "step_device_5": "mouse over",
    "step_device_6": "while on the device, you can click follow,",
    "step_device_7": "setelah perhatian",
    "step_device_8": "perangkat dapat digunakan dalam proyek ini sebagai",
    "step_device_9": "atas",
    "step_device_10": ",yang nyaman bagimu untuk menemukan peralatan yang kau pedulikan.",
    // 步骤四(操作)
    "step_operate_1": "Layout informasi peralatan yang lebih jelas",
    "step_operate_2": "Setelah memilih peralatan yang ingin Anda ketahui, Anda dapat cepat melayari diagram aliran energi, informasi peralatan, grafik data, analisis parameter, rincian data dan informasi alarm peralatan.",
  },
  "plantCode": {
    "codeApplication": "Aplikasi kode pengalaman",
    "haveDevice": "Jika Anda sudah memiliki peralatan,Bisa login setelah registrasi",
    "goRegister": "Pergi untuk mendaftar",
    "useDemo": "Belum ada kode undangan？Kode undangan untuk demonstrasi",
    "applyNow": "Lamar sekarang",
    "code_is_required": "Kode pengalaman tidak boleh kosong",
    "pleaseCode": "Silakan masukkan kode undangan",
    "pleaseName": "Silahkan masukan nama anda",
    "PleaseCompanyName": "Silakan masukkan nama perusahaan",
    "PleaseCompanyAddress": "Silakan masukkan alamat perusahaan",
    "PleaseNumber": "Silakan masukkan nomor kontak Anda",
    "PleaseEmail": "Masukkan email Anda",
    "PleaseApplication": "Tolong jelaskan alasan aplikasi Anda",
    "reasonNotEmpty": "Alasan lamaran tidak boleh kosong",
    "successfulApplication": "Aplikasi yang berhasil,Harap perhatikan informasi ponsel atau email Anda，kita akan kembali kepada kamu",
  },
  // 忘记账号
  "retrieveUser": {
    'forgetUser': 'Lupakan rekening',
    'illustrate': 'Jika Anda lupa rekening Anda, Anda dapat mendapatkan informasi rekening prompts dengan memasukkan nomor PN dari setiap perangkat di bawah rekening Anda, membantu Anda mengingat rekening Anda!',
    'pn': 'Silakan masukkan PN dari perangkat apapun di bawah akun Anda',
    'comfig': 'Konfirmasi',
    'Return_to_login': 'Return to login',
    'accountInfo': 'Informasi akun',
    'user': 'Nama penggunamu adalah',
    'phone': 'Nomor telepon yang terikat pada akunmu adalah',
    'email': 'E-mail yang berhubungan dengan akun Anda adalah',
    'pleasePn': 'Silakan masukkan perangkat PN',
    'pnError': 'PN yang Anda masukkan tidak benar',
    'pnErrorMsg': 'Koleksi data tidak ditemukan',
  },
  // 登录
  "login": {
    "login": "Gabung",
    "loginSuc": "Berhasil masuk",
    "no_account_yet": "Belum punya akun?",
    "remember_pwd": "Ingat kata sandi",
    "no_invitation": "Belum ada Kode? Silahkan hubungi kami!",
    "linkman": "Eybond",
    "signup": "Daftar",
    "usr": "Nama pengguna",
    "pwd": "Kata sandi",
    "sample_station": "Demo",
    "invitation": "Kode Pengalaman",
    "invitationLogin": "Pengalaman kode login",
    "forgotPwd": "Tidak ingat kata sandi?",
    "forgotUser": 'Lupakan rekening',
    "usrformat": "Format akun salah (2 <= Digit akun <= 32)",
    "pwdformat": "Format kata sandi salah (6 <= Digit kata sandi <= 32)",
    "YHLogin": "Login pengguna",
    "YZcode": "Harap masukkan kode verifikasi",
    "code": "Geser penggeser bawah untuk menyelesaikan teka-teki",
    "Swipe_right": "Geser kanan",
    "scan_login": "Pindai kode login",
    "open": "Buka",
    "Scancode_login": "Pindai kode login",
    "scanning": "Pindai",
    "success": "Berhasil",
    "Pleaseconfirm_login": "Harap konfirmasi login",
    "SmartESS": "SmartESS",
    "pv123": "PV123 ESS",
    'X_Tech': 'X-Tech',
    // APP下载
    "app_download": "Download APLIKASI",
    // 增
    "scan_download": "Download APLIKASI",
    "YZcode_format": "Format kode verifikasi tidak benar. Silakan masukkan nomor",
    "no_validitycode": "Kode undangan tidak berlaku",
		"auto_login": "Login Otomatis",
  },
  // 注册
  "signup": {
    "login": "Daftar",
    "code": "Kode verifikasi 6 digit",
    "pwd": "dalam 32 karakter, isi dengan akurat untuk menemukan kata sandi",
    "confirm_password": "setujui password",
    "phone": "Telepon",
    "phone_form": "dalam 32 karakter, isi dengan akurat untuk menemukan kata sandi",
    "pn": "14 atau 18 karakter (hanya angka dan huruf)",
    "usr": "2-32 karakter (China, huruf, angka, Garis bawah)",
    "email": "Surel",
    "email_form": "dalam 64 karakter, isi dengan akurat untuk menemukan kata sandi",
    "existing_account": "Sudah memiliki akun?",
    "Register_account": "Daftar akun",
    "signup": "Daftar",
    "emailSignup": "Registrasi Email",
    "phoneSignup": "Registrasi Phone",
    "registered": "Daftar",
    "success": "Pendaftaran berhasil!",
    "mobileformat": "Format nomor telepon salah (6-32 digit)",
    "mobileformat1": "Silakan masukkan nomor ponsel yang tepat",
    "emailformat": "Silakan masukkan kotak surat yang benar",
    "usrformat": "Kesalahan akun, 2-32 digit (hanya bahasa China, huruf, angka yang digarisbawahi)",
    "pwdformat": "Kesalahan format sandi, 6 ~ 32 digit (hanya angka, huruf, Garis bawah)",
    "pnformat": "Kesalahan format PN, 14 atau 18 digit (hanya angka dan huruf)",
    "qiang": "Kuat",
    "zhong": "Medium",
    "di": "Lemah",
    "qiangdu": "kekuatan kata sandi",
    "Byte_1": "Sudah masukan",
    "Byte_2": "Karakter",
    "usr_pl": "Nama akun",
    "pwd_pl": "Kata sandi",
    "confirm_pl": "Silakan masukkan kembali kata sandi Anda",
    "confirm_Pwdpl": "Setujui password",
    "email_pl": "Alamat email",
    "mobile_pl": "Nomor telepon",
    "code_pl": "Kode Verifikasi",
    "PN_pl": "PN",
    "too_simple": "Kata sandi terlalu sederhana, silakan masukkan kembali",
    "country_pl": "Negara atau wilayah",
  },
  "createPlant": {
    "imageLimit": "Gambar hanya mendukung format jpg, png, dan tidak boleh melebihi 8 juta",
    "fileExceed": "The file is too large",
    "uploadSuccess": "Unggah berhasil",
    "basic_settings": "Pengaturan dasar",
    "Standard_setting": "Pengaturan Standar",
    "System_settings": "Pengaturan sistem",
    "Solar_settings": "Pengaturan Energi Matahari",
    "Grid_settings": "Pengaturan Grid",
    "Battery_settings": "Pengaturan Baterai",
    "Battery_settingsTT": "Pengaturan Umum Baterai",
    "Battery_settings1": "Paket Baterai 1",
		"Battery_settings2": "Paket Baterai 2",
    "Work_settings2": "Atur status kerja sistem",
    "Machine_settings2": "Aktifkan kesiapan mesin",
    "Clear_settings2": "Hapus kesalahan",
    "Control_settings": "Pengaturan akumulator",
    "Load_setting": "Pengaturan Beban",
    "other_settings": "Pengaturan Lainnya",
    "Basic_setting": "Basis Mengatur",
    "Advanced_setting": "Pengaturan maju",
    "select_all": "Pilih Semua",
    "pv": "PV",
    "gd": "Jaringan",
    "bt": "Baterai",
    "bc": "Beban",
    "sy": "Sistem",
    "eg": "Generator",
    "hl": "BebanRumahTangga"
  },
  "Upload": {
    "Upload": "Unggah berhasil",
  },
  "401": {
    "oops": "Ups!",
    "noAuth": "Anda tidak memiliki izin untuk mengakses halaman ini",
    "goback": "Kembali ke sebelumnya",
    "gohome": "Kembali ke rumah",
  },
  "404": {
    "notFound": "halaman tidak ditemukan",
  },
  "menu": {
    "home": "Rumah",
    "account": "Akun",
    "device": "Alat",
    "overview": "Overview",
    "alarm": "Alarm",
    "setting": "Pengaturan",
    "personal": "Informasi pribadi",
    "basic": "Info dasar",
    "password": "Ubah Kata Sandi",
    "alarmSetting": "Pengaturan Alarm",
    "email": "Pengaturan Email",
    "mobile": "Pengaturan Seluler",
    "recharge": "Isi Ulang Pengaturan",
    "pay": "Isi Ulang Lalu Lintas",
    "record": "Isi Ulang Rekam",
    "rate": "Pengaturan Tarif",
    "customize": "Pengaturan Kustom",
    "firmware": "Firmware Upgrade Default",
    "firmwarenew": "Manajemen Firmware",
    "adaptiveFirmware": "Perangkat Tegap Adaptif",
    "intelligenceUpgrade": "Peningkatan Cerdas",
    "intelligenceUpgradeTitle": "Tidak ada paket peningkatan tersedia, silakan hubungi produsen",
    "intelligenceUpgradeTitle1": "Harap konfirmasi apakah perangkat harus melakukan peningkatan cerdas?",
    "intelligenceUpgradeTitle2": "Tidak ditemukan paket peningkatan yang cocok",
    "Total_user": "Total pengguna",
    "myDevice": "Perangkat saya",
    "strategy": "Strategi penataran lokal",
    "cloudsUpgrade": "Pemutakhiran Awan",
    "functionalApplication": "Aplikasi Fungsi",
    "datalogger": "Datalogger",
    "browseAccount": "Manajemen rekening bawah",

    "log": "Log perangkat akuisisi data",
    "actionLog": "Log Operasi",
    "Manufacturer": "Manajemen pembuat",
    "datalogger_list": "Daftar kolektor data",
    "manufacturer_account": "Akaun Pembuat",
    "manufacturer_code": "Kode pembuat",
    "protocol_binding": "Pengikatan protokol pengakuan data",
    "type_code": "Kode tipe perangkat pengakuan data",
    "protocol_change": "Perubahan protokol pengakuan data",
    "AIP_Interface": "Antaramuka API",
    "protocol_operation": "Alat operasi protokol",
    "recharge_management": "Manajemen muat ulang",
    "device_management": "manajemen perangkat",
    "KEY_List": "KEY List",
    "Protocol_instruction": "Manajemen instruksi protokol",
    "Raw_data": "Analisi data mentah",
    "Recharge_remedy": "Isi ulang obat",
    "device_function": "Fungsi manajemen peralatan",
    "Password_maintenance": "Pertahanan kata sandi item kontrol",
  },
  "header": {
    "plant_owner": "Pemilik Tanaman",
    "personal_infor": "Informasi pribadi",
    "change_password": "Ganti kata sandi",
    "bind_mobile": "Mengikat Ponsel",
    "bind_email": "Mengikat Surat",
    "language": "Bahasa",
    "log_out": "Keluar",
    "skin": "Ganti Skin",
    "shopping_mall": "Mall",
    "operating_manual": "Manual",
    "pleaseSelect": "Select",
    "pleaseSelect1": "Silakan pilih waktu",
    "pnAndAlias": "PN / Alias",
    "pnAndSN": "PN / SN"
  },
  "role": {
    "plantOwnerNew": "Pengguna biasa",
    "plantOwner": "Pemilik Tanaman",
    "manufacturer": "Akun Produsen",
    "distributor": "Distributor",
    "group": "Akun Grup",
    "viewer": "Penampil Pembangkit Listrik",
    "all": "Semua"
  },
  "statistic": {
    "All": "Semua",
    "regiontotal": "Luas total",
    "deviceStatus": "Status Perangkat",
    "regionPercent": "Rasio Regional",
    "userActivity": "Tingkat Aktivitas Pengguna",
    "dataUpdateTime": "Waktu Pembaruan Data",
    "normal": "Normal",
    "offline": "Offline",
    "Allstate": "Semua bagian",
    "warning": "Peringatan",
    "fault": "Kesalahan",
    "standby": "Bersiap",
    "totalDevice": "Semua Perangkat",
    "allDevice": "Semua Perangkat",
    "totalRegion": "Semua Wilayah",
    "other": "Lain",
    "allAccount": "Semua pengguna",
    "generalAccount": "Pengguna Umum",
    "adminAccount": "Pengguna Admin",
    "active": "Aktif",
    "inactive": "Tidak aktif",
    "pv": "Data Panel Fotovoltaik",
    "gd": "Data Grid",
    "sy": "Data Perangkat",
    "bt": "Data Baterai",
    "bc": "Muat Data"
  },
  "account": {
    "title_pwd": "Silakan masukkan kata sandi yang benar",
    "title_pwd1": "Silakan masukkan kata sandi 6-32 bit",
    "title_pwd2": "Silakan masukkan sandi baru lagi",
    "title_mobile": "Silakan masukkan nomor telepon 11 digit",
    "title_edit": "Silakan masukkan informasi yang perlu diedit",
    "title_info": "Silakan masukkan alamat email yang benar",
    "title_info1": "Silakan masukkan nomor telepon yang tepat",
    "allAccount": "Semua pengguna",
    "userAccount": "Pengguna",
    "groupAccount": "Kelompok",
    "uselists": "Daftar manajemen pengguna",
    "accountManage": "Kelola Akun",
    "groupManage": "Kelola Grup",
    "activeStatus": "Status Aktif",
    "accountGroup": "Grup pengguna",
    "createAccount": "Membuat",
    "relatedOwner": "Pemilik yang berhubungan",
    "relatedSuccess": "Asosiasi berhasil",
    "adminRelated": "Please select Administrator",
    "role": "Tipe Pengguna",
    "role1": "Tipe Pengguna:",
    "selectUserType": "Pilih tipe pengguna",
    "generalAccount": "Akun Umum",
    "manageAccount": "Akun Manajemen",
    "accountName": "Nama Pengguna",
    "accountName1": "Nama Pengguna:",
    "accountName2": "masukkan satu nama pengguna",
    "accountRole": "Role",
    "nickname": "Nama panggilan",
    "nickname1": "Nama panggilan:",
    "password": "Kata sandi",
    "password1": "Kata sandi:",
    "newPwd": "kata sandi baru",
    "newPwd1": "kata sandi baru:",
    "confirmpassword": "setujui password",
    "confirmpassword1": "setujui password:",
    "createTime": "Waktu penciptaan",
    "accountStatus": "status akun",
    "dataloggerNum": "Pencatat data",
    "deviceNum": "Kuantitas Perangkat",
    "projectNum": "Jumlah item",
    "lastLogin": "Login terakhir",
    "editUser": "Edit Pengguna",
    "editAccount": "Mengedit akun",
    "group": "Kelompok",
    "group1": "Kelompok:",
    "groupto": "Kelompokkan Ke",
    "changeGroup": "Ubah pengelompokan menjadi:",
    "chooseGroup": "Pilih satu grup",
    "changeGroupSuc": "Ubah pengelompokan berhasil",
    "defaultGroup": "Grup Default",
    "enable": "Memungkinkan",
    "disable": "Nonaktifkan",
    "confirmDisable": "Apakah Anda yakin ingin menonaktifkan pengguna ini?",
    "afterDisable": "Setelah dinonaktifkan, akun tidak akan dapat masuk, dan konten terkait dari akun tidak dapat dilihat atau diubah",
    "disableSuc": "Berhasil menonaktifkan akun",
    "confirmEnable": "Apakah Anda yakin ingin mengaktifkan pengguna ini?",
    "deleteUser": "Hapus pengguna",
    "binding": "Terikat",
    "ascription": "Deskripsi",
    "ascriptionSuccess": "Bergantung dengan sukses",
    "ascription_result": "Hasil atribut",
    "afterEnable": "Setelah diaktifkan, akun dapat dikembalikan untuk masuk, melihat atau mengubah konten terkait dari akun tersebut",
    "confirmDelete": "Konfirmasi untuk Hapus?",
    "notRecovered": "Itu tidak dapat dipulihkan setelah dihapus ...",
    "deleteSuc": "Berhasil dihapus",
    "resetPwd": "Atur Ulang Kata Sandi",
    "allTypeUser": "Semua jenis pengguna",
    "powerStationOwner": "Pemilik Pembangkit Listrik",
    "powerStationViewer": "Penampil Pembangkit Listrik",
    "admin": "Admin",
    "riyueyuan_lineSonAdmin": "Subadministrator garis produksi",
    "riyueyuan_SonAdmin": "Sub administrator",
    "nodata": "Tidak ada data",
    "reason": "Alasan untuk tidak menampilkan grafik mungkin:",
    "reason1": "Tidak ada data untuk peralatan",
    "reason2": "Perjanjian peralatan tidak memiliki bidang parameter generasi listrik, konsumsi listrik, listrik dibeli, listrik dijual, kapasitas muatan dan kapasitas pembuangan",
    "reason3": "Protokol peralatan tidak memiliki medan parameter generasi listrik, daya muatan, daya baterai dan daya jaringan",
    "createSuc": "Berhasil membuat akun",
    "resetPwdSuc": "Berhasil mengatur ulang kata sandi",
    "allGroup": "Semua Pengelompokan",
    "unclassified": "Tidak diklasifikasikan",
    "cannotRedirect": "Akun ini bukan akun penyimpanan energi, tidak dapat mengalihkan",
    "newPwdEmpty": "Kata sandi baru tidak boleh kosong, harap diisi",
    "accountList": "Daftar Akun",
    "mobile": "Seluler",
    "mobile1": "Seluler:",
    "email": "Surel",
    "email1": "Surel:",
    "modifiedsuccess": "Informasi pengguna berhasil diubah",
    "enablesuccess": "Berhasil diaktifkan",
    "disablesuccess": "Berhasil dinonaktifkan",
    "groupsuccess": "Tingkatkan grup dengan sukses",
    "pwdresetsuccess": "Berhasil mengatur ulang kata sandi",
    "Deletesuccessfully": "Hapus akun dengan sukses",
    "plantOwner": "Pemilik Tanaman",
    "distributor": "Distributor",
    "operate": "Beroperasi",
    "Edit": "Sunting",
    "Delete": "Menghapus",
    "cancel": "Membatalkan",
    "finish": "Selesai",
    "confirm": "Konfirmasi",
    "submit": "Kirimkan",
    "deletegroupsuccess": "Berhasil keluar dari grup",
    "deletegroup": "Pindah dari grup ini",
    "currentTotal": "saat ini",
    "projects": "proyek",
    "searchPro": "Cari item",
    "devices": "perangkat",
    "accounts": "akun",
    "placeholder": "Cari Nama Pengguna / nomor ponsel",
    "placeholder1": "Masukkan Satu Nama Pengguna / nomor ponsel",
    "lastLoginTs": "Waktu daftar masuk terakhir",
    "enterHome": "Pulang",
    "ownedDevices": "Owned Equipment",
    "Distribution_collector": "Koleksor distribusi",
    "tooltipContent": "Administrator dapat menyerahkan semua kolektor data di bawah perintah kepada pengedar bawah perintah melalui nomor perintah",
    "Distribution_method": "Metode distribusi",
    "Batch_allocation": "Allokasi seri",
    "Individual_allocation": "Allokasi individu",
    "Order_allocation": "Allokasi perintah",
    "PNNum": "PN No",
    "order_number": "nomor perintah",
    "Allocation_result": "Hasil alokasi",
    "Assigned_successfully": "Assigned successfully",
    "order_check": "cek",
    "Confirm_assignment": "Konfirmasi tugas ke",
    "IsIt": "/ Ya.",
    "limitFormat": "Hanya berkas dalam format \"xlsx\" dan \"xls\" dapat diunggah",
    "Ple_orderNum": "Silakan masukkan nomor perintah",
    "Ple_orderNum1": "Silakan masukkan nomor perintah yang benar",
    "Ple_orderNum2": "Perintah ini memiliki",
    "Ple_orderNum3": "pengumpul, konfirmasi alokasi ke",
    "err_orderNum": "Dalam perintah",
    "err_orderNum1": "pengumpul telah diikat. Silakan konfirmasi bahwa kolektor dalam perintah tidak diikat",
    "dataogger_swith": "Tambah perangkat akuisisi data",
    "dataogger_swithTip": "Dapatkah akun ini memiliki izin untuk menambah kolektor data",
    "account_number": "Nomor rekening",
    "Role_authority": "jurisdiksi",
    "authority_Management": "Manajemen izin",
    "Related_roles": "Peran terhubung",
    "Ple_role1": "Silakan pilih peran yang terkait",
    "Ple_role2": "Silakan masukkan nama/ID peran",
    "Add_role": "Tambah peran",
    "Edit_role": "Edit Peran",
    "Role_id": "ID Role",
    "Role_name": "Nama peran",
    "Ple_role3": "Silakan masukkan nama peran",
    "Role_des": "Deskripsi peran",
    "Ple_role4": "Silakan masukkan deskripsi peran",
    "module": "Modular",
    "First_page": "halaman",
    "Secondary_page": "Halaman kedua",
    "Function_points": "fungsi",
    "Remove_role": "Hapus Rol",
    "Ple_role5": "Silakan periksa hak akaun",
    "No_permission_prompt": "Tidak ada izin, tolong hubungi administrator tingkat tinggi",
    "Ple_role6": "Nama peran sudah ada, silakan masukkan kembali",
    "limit_UserTypeNum": "Melewati batas, tipe akun ini sudah ada",
    "limit_UserTypeDataPermission": "Akun dealer tidak dapat mengikat peran dengan izin data yang dipilih.",
    "edit_limit_UserTypeDataPermission": "Peran terkait dengan akun dealer dan izin data tidak dapat diedit.",
    "dataPermission": "Izin data",
    "functionalPermission": "Izin fungsional"
  },
  "group": {
    "Create_groups": "Buat Grup",
    "Edit_groups": "Edit Grup",
    "Groups_list": "Daftar Grup",
    "Group_name": "Nama grup",
    "Group_name1": "Nama grup：",
    "userCount": "Hitungan Pengguna",
    "note": "Catatan",
    "note1": "Catatan：",
    "Operate": "Beroperasi",
    "Delete": "Menghapus",
    "cancel": "Membatalkan",
    "finish": "Selesai",
    "confirm": "Konfirmasi",
    "deletegroup": "Hapus Grup",
    "deleteConfirm": "Apakah Anda yakin untuk menghapus grup ini?",
    "entername": "Harap masukkan nama grup",
    "deletesuc": "Hapus grup dengan sukses",
    "creatsuc": "Buat grup berhasil",
    "editsuc": "Edit grup berhasil"
  },
  "device": {
    'set': 'Mengatur',
		"ownerShip": "Perubahan Pemilik",
    "oldOwner": "Pemilik Sebelumnya:",
    "nweOwner": "Pemilik Baru:",
    "loading": "Memuat...",
    "moreLoading": "Gulir untuk memuat lebih banyak",
    'pleaseDate': 'Silakan pilih tanggal',
    'noDate': 'Tidak dapat memilih tanggal masa depan',
    'deviceDebug': 'Penyahpepijat peralatan',
    'upgradeType': 'Metode penataran:',
    'defaultUpgrade': 'Pemutakhiran lalai',
    'cloudUpgrade': 'Pemutakhiran Awan',
    'continueUpgrade': 'Teruskan meningkatkan',
    'continueUpgradeSuccess': 'Successfully upgraded and added',
    'step': 'Langkah awal:',
    'firmware_step_message': 'Silakan masukkan langkah',
    'numberRlues': 'Silakan masukkan jumlah langkah yang tepat',
    'firmware_package_message': 'Silakan pilih peralatan keras',
    'firmware_type_message': 'Silakan pilih tipe',
    'baudrate_message': 'Silakan pilih Baud',
    'device_continueUpgrade': 'Perangkat terus meningkatkan',
    'read': 'Baca',
    'distribute': 'Surat',
    "optionTitle": "Dipilih",
    "optionTitle1": "term",
    "optionTitle2": "Pemilihan parameter perangkat tidak dapat melebihi 4",
    "optionTitle4": "Pemilihan parameter perangkat tidak dapat melebihi 12",
    "optionTitle3": "Silakan jangan memilih pilihan dengan lebih dari 2 unit berbeda",
    "upBatchDeviceTip": "Perhatian: Pemutakhiran batch adalah untuk meningkatkan perangkat kuat dari perangkat yang sama untuk beberapa perangkat. Jika Anda tidak tahu perangkat kuat yang cocok untuk perangkat, silakan pilih dengan hati-hati!",
    "upSuccessDevice": "Sukses",
    "upFailDevice": "Gagal",
    "brandDevice": "Alat",
    "brand0": "Mesin Penyimpanan Energi",
    "brand1": "Inverter Off-grid",
    "brand2": "Inverter",
    "brand3": "Unit Penyimpanan Energi",
    "Allthemachines": "Semua perlengkapan",
    "device": "Peralatan",
    "datalogger": "Datalogger",
    "deviceList": "Daftar perangkat",
    "dataloggerList": "Daftar Datalogger",
    "followList": "Mengikuti perangkat",
    "proList": "Proyek list",
    "pro": "Proyek",
    "deviceName": "Nama perangkat",
    "dataview": "Real time parameters",
    "dataTips": "Perangkat saat ini diluar talian dan tidak memiliki data waktu nyata.",
    "overview": "Gambaran Statistik",
    "chart": "Bagan Data",
    "analysis": "Analisis Parameter",
    "clause": "Detail Data",
    "Current_data": "Data sekarang",
    "chosenParam": "Parameter yang Dipilih",
    "optionalParam": "Parameter Opsional",
    "reset": "Setel ulang",
    "energyFlow": "Kinerja Energi",
    "device_name": "Nama perangkat",
    "device_pn": "Perangkat PN",
    "device_sn": "Perangkat SN",
    "device_status": "Status Perangkat",
    "device_upgrade1": "Rekaman penataran terakhir",
    "device_upgradeFirmware": "Pilih paket perangkat keras untuk meningkatkan perangkat",
    "device_upgradeTime": "Waktu penataran",
    "device_upgradeName": "Upgrade firmware name",
    "device_upgradeStatus": "Status Upgrade",
    "device_upgradeProgress": "Kemajuan",
    "device_type": "Tipe perangkat",
    "device_code": "Protokol",
    "device_code_form": "Protokol：",
    "device_model": "Model Perangkat",
    "User_belong": "Pengguna",
    "field": "Kontrol medan",
    "datalogger_pn": "Datalogger PN",
    "coll_alias": "Datalogger Alias",
    "device_address": "Alamat Perangkat",
    "generation": "Generasi",
    "grid": "Kotak",
    "inverter": "Inverter",
    "battery": "Baterai",
    "consumption": "Konsumsi",
    "relay": "Relay",
    "alternator": "Generator",
    "familyLoad": "Beban Keluarga",
    "solar": "Solar",
    "cur_today": "Hari ini",
    "cur_thismonth": "Bulan ini",
    "cur_thisyear": "Tahun ini",
    "cur_day": "",
    "cur_month": ".",
    "cur_year": ".",
    "day": "Kekuatan waktu nyata",
    "month": "Elektricitas bulan ini",
    "year": "Elektricitas year ini",
    "all": "Total listrik",
    "pvPower": "Pembangkit listrik",
    "gridPower": "Kekuatan Jaringan",
    "batteryPower": "Daya baterai",
    "loadPower": "Daya Beban",
    "generated": "Energi yang Dihasilkan",
    "charged": "Energi Dibebankan",
    "discharged": "Energi Terbuang",
    "sold": "Energi Terjual",
    "bought": "Energi yang Dibeli",
    "used": "Energi yang Digunakan",
    "normal": "Normal",
    "offline": "Offline",
    "warning": "Peringatan",
    "fault": "Kesalahan",
    "standby": "Bersiap",
    "universal_firmware": "Firmware Universal",
    "communication_firmware": "Firmware Komunikasi",
    "control_firmware1": "Kontrol Firmware 1",
    "control_firmware2": "Kontrol Firmware 2",
    "control_firmware_bms": "Hardware BMS",
    "control_firmware_slavmcu": "Hardware Slavmcu",
    "default": "Default",
    "modifySuc": "Berhasil diubah",
    "instruction_response": "Mengirim instruksi, menunggu jawaban ......",
    "debug_suc": "Debugging berhasil",
    "Debugfail": "Debug gagal, peralatan sedang offline.",
    "Send_suc": "Kirim perintah berhasil",
    "Send_Input": "Harap masukkan nilai operasi untuk dikirim",
    "Send_fail": "Perintah pengiriman gagal",
    "fileExceed": "Ukuran file terlampaui",
    "uploadSuccess": "Unggah berhasil",
    "error1": "Hanya file dalam format \".bin\" dan \".hex\" yang dapat diunggah",
    "file_fist": "Silakan pilih firmware terlebih dahulu",
    "updatefail": "Upgrade gagal, perangkat offline",
    "update_suc": "Berhasil memperbarui",
    "deleteSuc": "Berhasil dihapus",
    "Operation": "Operasi",
    "edit": "Sunting",
    "debug": "Debug",
    "upgrade": "Batch upgrade",
    "upgrade1": "Upgrade",
    "more": "Lebih Banyak Aksi",
    "one_click_read": "Baca dengan Satu Klik",
    "cloudsUpgrade": "Pemutakhiran Awan",
    "queryUpgrade": "Kemajuan penataran pertanyaan seri",
    "control": "Kontrol",
    "delete": "Menghapus",
    "modify_alias": "Ubah Perangkat",
    "serial_number": "Perangkat SN",
    "device_alias": "Nama perangkat",
    "cancel": "Membatalkan",
    "confirm": "Konfirmasi",
    "Device_sn": "Nomor Seri Perangkat",
    "Device_pn": "Datalog PN",
    "Instruction": "Petunjuk",
    "such_as": "Ketik perintah Anda, seperti: AA BB CC DD EE FF",
    "return_content": "Kembalikan Konten",
    "send": "Kirim",
    "clear_data": "Hapus data",
    "Field_Name": "Nama Bidang",
    "Unit": "Satuan",
    "current_val": "Val saat ini",
    "Battery_voltage": "Voltase baterai",
    "Magnification": "Pembesaran",
    "Send_Command": "Kirim Perintah",
    "device_upgrade": "Peningkatan Firmware Perangkat",
    "device_cloudsUpgrade": "Pemutakhiran Awan Perangkat",
    "select_firmware": "Firmware",
    "select_file": "Pilih file firmware",
    "firmware_type": "Jenis Firmware",
    "select_type": "Pilih jenis firmware",
    "upgrade_brate": "Tingkat Baud",
    "select_brate": "Silakan Pilih rentang baud ",
    "Upload": "Unggah",
    "Upload1": "Menguasai perangkat keras baru",
    "confirm_deldte": "Konfirmasi untuk Hapus??",
    "deleteDevice": "Hapus Perangkat",
    "Today_income": "Daftar generasi listrik sehari",
    "Cumulative_income": "Total pendapatan dari generasi listrik",
    "sellProfit_Today": "Penjualan listrik sehari",
    "sellProfit_Total": "Total pendapatan dari penjualan listrik",
    "buyProfit_Today": "Biaya pembelian listrik saat ini",
    "buyProfit_Total": "Total biaya pembelian listrik",
    "noAuth": "Tidak ada pengguna, tidak ada izin untuk melihat",
    "statistic": "Statistik",
    "protocolStatistic": "Statistik Protokol",
    "chooseProtocol": "Pilih Protokol",
    "parameter": "Parameter",
    "value": "Nilai",
    "Upgrading": "Mengupgrade, harap tunggu",
    "System_Failed": "Sistem gagal memulai proses peningkatan perangkat karena anomali komunikasi atau alasan lain",
    "Device_Offline": "Perangkat atau datalogger sedang offline",
    "In_Upgrading": "Perangkat atau datalogger sudah di-upgrade",
    "Update_Completed": "pembaruan selesai",
    "Voltage": "Tegangan",
    "Electric": "Listrik",
    "power": "Kekuasaan",
    "frequency": "Frekuensi",
    "Input_form": "Tabel masukan",
    "add": "Menambahkan",
    "Output_table": "Tabel keluaran",
    "Please_parameter": "Pilih satu parameter",
    "Successfully_modified": "Berhasil diubah",
    "edit_control": "Edit izin kontrol perangkat",
    "Equipment_agreement": "Perjanjian peralatan",
    "Check_all": "Periksa semua",
    "Cancel_all": "Batalkan semua",
    "administrator_cansee": "Izin yang dipilih dapat dilihat oleh pemilik, dan delegasi tidak terlihat",
    "person_cansee": "Izin yang dipilih terlihat oleh administrator bawahan, dan delegasi tidak terlihat",
    "noDataPlease": "Tidak ada data, pilih waktu baru",
    "admin_authority": "administrator",
    "person_authority": "oleh pemilik",
    "Sn_deviceName": "SN / Nama perangkat / PN / Pengguna",
    "Datalogger_belong": "Data collector",
    "detail": "Lihat rincian",
    "pageSize": "Tampil",
    "follow": "mengikuti",
    "unfollow": "unfollow",
    "report": "laporan",
    "timeSlot": "timeSlot",
    "clear_val": "hapus",
    "copy_val": "Salin",
    "copy_val_yes": "Salin berhasil",
    "copy_val_no": "salinan gagal",
    "deviceInfo": "Informasi peralatan",
    "alarmInfo": "Informasi penggera",
    "deviceNo": "Anda belum menambahkan perangkat belum",
    "showParam": "Tampilkan parameter",
    "selecParameters": "Parameter selected",
    "refresh": "Segar",
    "obtain": "Mendapatkan",
    "moveResults": "Pindahkan hasil",
    "moveSuc": "Pindah berhasil",
    "maxSelect": "Hanya 7 parameter yang bisa diperiksa paling banyak",
    "minSelect": "Setidaknya 1 parameter perlu diperiksa",
    "loadMore": "Muat lebih ...",
    "upDevice": "Upgrade Device",
    "addUpgrade": "Tambah Tugas Upgrade",
    "upgradeProgress": "Kemajuan penataran saat ini",
    "deviceUpgradeProgress": "Kemajuan peningkatan peralatan",
    "addUpgradeSuccess": "Sangat berhasil ditambah",
        "unbind_tips": "Perangkat ini tidak terikat dengan pemilik, harap ikat pemilik terlebih dahulu",
    "device_code1": "Kode Perangkat"
  },
  "alarm": {
    "device_Warning": "Alarm peralatan",
    "device_Error": "Kesalahan peralatan",
    "device_Fault": "Kegagalan peralatan",
    "Alarm_Event": "Peristiwa penggera",
    "Today_Alarm": "Hari ini Alarm",
    "Alarm_Type": "Jenis Alarm",
    "Device_Type": "Tipe perangkat",
    "Alarm_Status": "Status Alarm",
    "Alarm_List": "Daftar Alarm",
    "deletes": "Menghapus",
    "tips": "Tips",
    "details": "rincian",
    "alarmDetails": "Rincian penggera",
    "alarmInfo": "Situasi penggera",
    "alarmDevice": "Informasi Peranti",
    "delete_alarm": "Anda yakin ingin menghapus notifikasi ini?",
    "Cancel": "Membatalkan",
    "Confirm": "Konfirmasi",
    "Close": "Tutup",
    "processed": "Diproses",
    "untreated": "Tidak diobati",
    "allAlarm": "Total",
    "alarmStatus": "Jumlah total peristiwa alarm",
    "warningTitle": "Jumlah alarm dalam 7 hari terakhir",
    "faultTitle": "Jumlah kegagalan dalam 7 hari terakhir",
    "alarmNum": "Jumlah alarm",
    "faultNum": "Jumlah kesalahan",
    "all": "Semua",
    "warning": "Peringatan",
    "error": "Kesalahan",
    "fault": "Kesalahan",
    "offline": "Offline",
    "inverter": "Inverter",
    "monitor": "Monitor lingkungan",
    "smart_meters": "Pengukur Cerdas",
    "combining_manifolds": "Menggabungkan Manifold",
    "Camera": "Kamera",
    "Battery": "Baterai",
    "Charger": "Pengisi daya",
    "storage": "Pengontrol Penyimpanan Energi",
    "Prevent_arcing_island": "Mencegah Pulau Arcing",
    "Microinverter": "Microinverter",
    "Occurrence_time": "Waktu Kejadian",
    "endtime": "Akhir waktu",
    "Device_Name": "Nama perangkat",
    "Device_PN": "Perangkat PN",
    "Plant": "Menanam",
    "Alarm_Code": "Kode Alarm",
    "Alarm_Describe": "Menjelaskan Alarm",
    "Device_SN": "Perangkat SN",
    "device_alias": "Alias ​​Perangkat",
    "device_address": "Alamat Perangkat",
    "User": "Pengguna",
    "Status": "Status",
    "Operation": "Operasi",
    "Delete_selected": "Hapus yang Dipilih",
    "deleted_successfully": "Alarm berhasil dihapus!",
    "Alarm_Msg": "Pesan Baru",
    "Intro_Msg": "Novice guidance",
    "Alarm_Read": "Anda telah membaca semua pemberitahuan alarm",
    "Alarm_data": "Tidak ada berita terbaru untuk saat ini!",
    "Alarm_Message": "Anda",
    "Alarm_Message1": "eranti muncul",
    "curSelected": "Saat ini dipilih",
    "_Data": "data",
    "more": "lebih",
    "ruleManage": "Manajemen aturan penapisan penggera",
    "ruleNew": "Peraturan baru",
    "ruleName": "Nama aturan",
    "timeSlot": "Slot waktu",
    "deviceType": "Jenis peralatan",
    "deviceFilter": "Peralatan penapisan",
    "alrmType": "Penapis jenis alarm",
    "alrmDes": "Penapis deskripsi alarm",
    "filterHistory": "Sejarah penapis",
    "clearHistory": "Kosongkan sejarah",
    "view": "lihat",
    "back": "Kembali",
    "exportArchive": "Ekspor alarm terarsip",
    "archiveRecord": "Arsip",
    "archiveTip": "Daftar ini mencakup semua alarm yang belum diproses dan catatan yang telah diproses dalam 7 hari"
  },
  "datalogger": {
    'activeStatus': 'Status aktivasi',
    'Active': 'Aktifkan',
    'notActive': 'Tidak aktif',
    'timeZone': 'Zona waktu',
    "please_title": "Silakan masukkan 'YES' untuk mengkonfirmasi reset pabrik",
    "frequency": "Frekuensi koleksi",
    "heartbeat": "Pukulan jantung",
    "warehousing_time": "waktu penyimpanan",
    "start_address": "Mencari alamat awal",
    "deadline_address": "Mencari alamat tanggal",
    "title_usr": "Koleksor data ini tidak memiliki pengguna terkait",
    "datalogger_log": "Log",
    "min_addr": "alamat minimum",
    "max_addr": "Alamat maksimum",
    "transmission": "Identifikasi transparan murni",
    "transparent_set": "Set protokol transparan murni",
    "devcode": "Kode pembuat peralatan",
    "protocol_code": "Protocol manufacturer code",
    "domain_name": "Nama domain online",
    "transmission1": "Mode koleksi lokal",
    "transmission2": "Modus transparan murni",
    "noDate": "Silakan pilih tanggal dalam 3 hari",
    "paramSetting": "Parameter settings",
    "paramName": "Parameter name",
    "paramPar": "Nomor parameter",
    "paramVal": "Nilai parameter",
    "dataloggerView": "rincian kolektor data",
    "describe": "Description",
    "field_name": "Nama medan",
    "checkVal": "nilai numerik",
    "resetTitle1": "Apakah Anda yakin ingin reset kolektor data? (1: membuatnya terdaftar lagi, 2: membersihkan perangkat subordinat, 3: hapus semua data di bawah kolektor)",
    "unbingTitle": "Apakah Anda yakin ingin melepaskan kolektor data? (1: Lepaskan administrator pengedar; 2: Rebind, silakan log masuk ke administrator pengedar yang sesuai untuk menambah kolektor data)",
    "getTitle": "Acquisition parameter",
    "postTitle": "Parameter Settings",
    "debugeTitle": "Menetapkan debugging",
    "getName": "Acquisition parameter (desimal)",
    "postName": "Nomor parameter (desimal)",
    "debugeName": "Perintah:",
    "getVal": "Nilai saat ini:",
    "postVal": "Menetapkan nilai:",
    "debugeVal": "Hasil:",
    "debugeAddr": "Alamat perangkat:",
    "getSucc": "Diterima dengan sukses",
    "postSucc": "Set dengan sukses",
    "debugeSucc": "Successfully issued",
    "copyVal": "Salin nilai",
    "huoqu": "Get",
    "shezhi": "Pengaturan",
    "xiafa": "Perintah Keluaran",
    "copy": "Salin berhasil",
    "flowCard": "Tidak ditemukan kartu yang valid",
    "province": "Provinsi/Negara bagian",
    "city": " Kota",
    "county": "Wilayah/Distrik",
    "country": "Negara",
    "Flowcard_status": "Status kartu aliran",
    "GPRS_traffic": "lalu lintas GPRS",
    "upBatchDataloggerTip": "Perhatian: pemutakhiran batch adalah untuk meningkatkan perangkat keras kolektor data yang sama untuk kolektor data berbilang. Jika Anda tidak tahu perangkat keras yang cocok untuk kolektor data, silakan pilih dengan hati-hati!",
    "upSuccessDatalogger": "Sukses",
    "upFailDatalogger": "Gagal",
    "Datalogger_Status": "Status Datalogger",
    "com_method": "Metode Komunikasi",
    "Datalogger_PN": "Datalogger PN",
    "Datalogger_List": "Daftar Datalogger",
    "Datalogger_Name": "Nama Datalogger",
    "Ple_PN": "Silakan masukkan nomor PN dari Datalogger",
    "Ple_Alias": "Silakan masukkan nama Datalogger",
    "Datalogger_type": "Jenis Datalogger",
    "Datalogger_model": "Model",
    "Datalogger_method": "Jenis Komunikasi",
    "Status": "Status",
    "usr_belong": "Pengguna",
    "administrator": "Administrator",
    "Communication_balance": "Keseimbangan Komunikasi",
    "load": "Beban",
    "Firmware_Version": "Versi Firmware",
    "signal": "Sinyal",
    "Operation": "Operasi",
    "edit": "Sunting",
    "reboot": "Restart",
    "unbind": "Tidak mengikat",
    "more": "Lebih",
    "resetData": "Reset Data",
    "unbindUsr": "Membatalkan Pemilik",
    "debug": "Debug",
    "upgrade": "Meningkatkan",
    "delete": "Menghapus",
    "deleteTitle": "Hapus datalogger",
    "reset": "Reset",
    "resetCode": "Silakan masukkan YES untuk mengkonfirmasi",
    "modify_datalog": "Modifikasi informasi datalog",
    "cancel": "Membatalkan",
    "confirm": "Konfirmasi",
    "datalogger_debug": "Debug Datalogger",
    "communication_address": "Alamat Komunikasi",
    "Instruction": "Petunjuk",
    "such_as": "Ketik perintah Anda, seperti: AA BB CC DD EE FF",
    "return_content": "Kembalikan Konten",
    "send": "Kirim",
    "check": "Pemeriksaan",
    "InstructionType": "Format Instruksi",
    "endMarker": "Penanda Akhir",
    "noMarker": "Tanpa Penanda Akhir",
    "noCheck": "Tanpa Pemeriksaan",
    "InstructionIssue": "Kirim Instruksi",
    "Insufficient": "Jumlah Tidak Cukup",
    "clear_data": "Hapus data",
    "device_upgrade": "Pembaruan firmware perangkat",
    "select_firmware": "Firmware",
    "select_file": "Pilih file firmware",
    "Upload": "Unggah",
    "prompt_message": "Pesan Prompt",
    "confirm_deldte": "Setelah kolektor data dihapus, Anda tidak punya hak untuk mengelola semua data yang berhubungan dengan Datalogger",
    "Normal": "Normal",
    "Online": "Di talian",
    "Offline": "Offline",
    "Normal1": "Online status",
    "Offline1": "Offline state",
    "Allstate": "Semua negara bagian",
    "modifySuc": "Berhasil diubah",
    "resetSuc": "Reset berhasil",
    "unbindSuc": "Pengikatan berhasil",
    "devaddrfail": "Bidang alamat komunikasi tidak boleh kosong",
    "Debugfail": "Debug gagal, datalogger sedang offline",
    "instruction_response": "Mengirim instruksi, menunggu jawaban ...",
    "fileExceed": "Ukuran file terlampaui",
    "uploadSuccess": "Unggah berhasil",
    "error1": "Hanya file dalam format \".bin\" dan \".hex\" yang dapat diunggah",
    "file_fist": "Silakan pilih firmware terlebih dahulu",
    "updatefail": "Upgrade gagal, datalogger sedang offline",
    "update_suc": "Berhasil memperbarui",
    "deleteSuc": "Berhasil dihapus",
    "debug_suc": "Debugging berhasil",
    "create": "Membuat",
    "addSuc": "Berhasil menambahkan datalogger",
    "add": "Buat Datalogger",
    "addScq": "Buat Datalogger",
    "batchAddScq": "Batch buat Datalogger",
    "editDatalogger": "Ubah Datalogger",
    "editDataloggerName": "Sunting Datalogger",
    "resetDataloggerName": "Reset Datalogger",
    "unbindDataloggerName": "Dataloger tidak mengikat",
    "resetDataloggerExplain": "This function is mainly used to facilitate manufacturers to clear cloud test data on equipment. Setelah reset datalogger, data sejarah perangkat akan dibersihkan. Setelah beroperasi, data sejarah perangkat tidak dapat dipulihkan. Silakan berhati-hati!",
    "unbindDataloggerExplain": "Fungsi ini terutama digunakan untuk memudahkan pembuat untuk melepaskan rekening ujian (pemilik) dari datalogger setelah ujian sebelum pengiriman. Silakan beroperasikan fungsi ini dengan hati-hati. Setelah operasi selesai, pelanggan perlu mengembalikan ulang datalogger.",
    "rebootDataloggerName": "Mulai ulang Datalogger",
    "rebootDataloggerSuc": "Datalogger dimulai dengan sukses",
    "fixOnRebootDataloggerName": "Konfirmasi untuk memulai ulang Datalogger:",
    "fixOnRebootDataloggerName1": "apakah itu?",
    "unbindTitle": "Silakan masukkan \"YES\" untuk mengkonfirmasi bahwa Anda ingin melepaskan dataloger dari pemilik terminal saat ini.",
    "resetTitle": "Silakan masukkan \"YES\" dan konfirmasi untuk reset dataloger。",
    "editSuc": "Ubah datalogger berhasil",
    "basic_info": "Info dasar",
    "datalogger_pn": "Datalogger PN",
    "datalogger_name": "Nama Datalogger",
    "nominalPower": "Kekuatan Nominal",
    "install_date": "Tanggal Pemasangan",
    "installer": "Pemasang",
    "location_info": "informasi lokasi",
    "location_info1": "informasi geografik",
    "address": "Alamat Datalogger",
    "dataloggerAddress": "Alamat terperinci",
    "enterPosition": "Masukkan Alamat Datalogger",
    "latitude": "Garis Lintang",
    "longitude": "Garis bujur",
    "currentAddress": "Alamat saat ini:",
    "timezone": "Zona waktu",
    "timezone1": "Zona waktu",
    "cp1": "Silakan pilih tanggal penginstalan",
    "cp2": "Pilih zona waktu",
    "cp3": "Harap masukkan daya pengenal",
    "cp4": "Pilih mata uang",
    "income_info": "Informasi Pendapatan",
    "currency": "Mata Uang Pendapatan",
    "buyProfit": "Penghasilan Daya Harga",
    "sellProfit": "Jual Power Harga",
    "unitProfit": "Menggunakan Power Harga",
    "generateProfit": "Generate Power Harga:",
    "noNegative": "Silakan masukkan nomor bukan negatif",
    "buyProfitNew": "Buying Power Harga",
    "sellProfitNew": "Selling Power Harga",
    "generateProfitNew": "Generate Power Harga",
    "add_datalogger": "Tambahkan Datalogger",
    "add_suc": "berhasil ditambahkan",
    "district": "Distrik Administratif",
    "longi_lati": "Longitude dan latitud",
    "cp5": "Silakan masukkan nama perangkat",
    "cp6": "Silakan pilih item",
    "cp7": "Silakan pilih latitud dan longitud",
    "lonRange": "Nomor dengan jangkauan panjang -180 hingga 180",
    "latRange": "Nomor dalam jangkauan latitud -90 hingga 90",
    "cp9": "Silakan masukkan alamat saat ini",
    "cp10": "Silakan masukkan nama proyek",
    "basicInfo": "informasi penting",
    "connectionInfo": "Informasi koneksi",
    "finishAdding": "Selesai menambahkan",
    "addResults": "Tambah hasil",
    "addedSuccessfully": "Ditambah dengan sukses",
    "finish": "selesai",
    "continueAdding": "Lanjutkan menambah",
    "nowNoAdd": "Belum ditambah",
    "reAdd": "Tambah ulang",
    "editResults": "Hasil modifikasi",
    "resetResults": "Reset Hasil",
    "unbindResults": "Hasil tidak mengikat",
    "delResults": "Hapus hasil",
    "locationTip": "Peringatan: Dalam kasus posisi tidak tepat atau gagal posisi, dapat dimasukkan secara manual.",
    "upDatalogger": "Upgrade Datalogger",
    "dataloggerTipName": "Perangkat ini telah ditambah oleh",
        "batch_edit_datalogger": "Edit datalogger secara massal",
        "upload_column_tips": "Pengingat: Kolom A adalah PN Datalogger, Kolom B adalah jumlah beban, Kolom C adalah baud rate, Kolom D adalah protokol komunikasi, Kolom E adalah kode produsen perangkat, Kolom F adalah kode produsen protokol, Kolom G adalah mode pengumpulan, Kolom H adalah alamat komunikasi min, Kolom I adalah alamat komunikasi max, tidak perlu judul, lihat gambar di bawah",
        "upload_csv_tips": "Pengingat: Format file harus csv, lihat gambar di bawah untuk konten",
        "click_enlarge": "Klik untuk memperbesar detail",
            "collector_expire_time": "Waktu kedaluwarsa kolektor",
            "collection_cycle": "Siklus pengumpulan",
                "ascii_display": "Tampilan ASCII:"
  },
  "map": {
    "sn": "Perangkat SN",
    "datalogger": "Datalogger Alias:",
    "address": "Alamat:",
  },
  "rate": {
    "device_status": "Status Perangkat",
    "datalogger_pn": "Datalogger PN",
    "datalogger_pns": "Datalogger PN：",
    "rate_list": "Daftar Tarif",
    "datalogger_name": "Nama Datalogger",
    "status": "Status",
    "Income_currency": "Mata Uang Pendapatan",
    "Income_currencys": "Mata Uang Pendapatan：",
    "generate_Rate": "Tingkat Pembangkit Listrik",
    "generate_Rates": "Tingkat Pembangkit Listrik：",
    "sell_Rate": "Tingkat Jual Daya",
    "sell_Rates": "Tingkat Jual Daya：",
    "buy_Rate": "Tingkat Pembelian Daya",
    "buy_Rates": "Tingkat Pembelian Daya：",
    "operating": "Pengoperasian",
    "edit": "Sunting",
    "rate": "Nilai",
    "cancel": "Membatalkan",
    "confirm": "Konfirmasi",
    "modifySuc": "Berhasil diubah",
    "resetSuc": "Reset berhasil",
    "unbindSuc": "Pengikatan berhasil",
  },
  // 增
  "auxiliary": {
    "auxiliaryFunction": "Auxiliary Function",
    "chartSupplement": 'Carta realistis',
    "realChart": 'Setelah dibuka, grafik menunjukkan data nyata.',
  },
  // 增
  "strategy": {
    'strategyUpgrade': 'Senarai Strategi Upgrade',
    'to': 'kembali',
    'UpgFirmware': 'Manajemen firmware lokal',
    'strategyIntro': 'Penjelasan dari proses pemutar lokal',
    'strategyInfor': 'Informasi Keutamaan Kebijakan',
    'strategyIntro1': 'Deskripsi: Modul fungsi ini hanya untuk pemutar perangkat firmware lokal Bluetooth. Jika Anda ingin memperutar perangkat firmware seperti Wi Fi atau 4G, silakan pindah ke [Operasi Upgrade List Device Management]',
    'stategyStep2': 'Paket versi firmware baru',
    'stategyStep3': 'Memuat naik berkas paket versi firmware dalam manajemen firmware lokal',
    'stategyStep4': 'Pemutakhiran Lokal APP',
    'stategyStep5': 'Setelah strategi mengambil efek, APP menerima peringatan penataran dan dapat menataran lokal',
    'stategyStep6': 'Tambah strategi penataran',
    'stategyStep7': 'Tambah strategi baru dalam daftar strategi penataran, pilih Upgrade Firmware, menetapkan metode penataran dan mengambil efek, asosiasikan perangkat penataran, dan menghasilkan strategi penataran',
    'stategyStep8': 'Lihat catatan penataran',
    'stategyStep9': 'Lihat status pemutar perangkat dan hasil',
    'stategyDetail': 'Nama Polisi',
    'stategyDetail1': 'Kemaskini Firmware',
    'stategyDetail2': 'Ukuran Firmware (KB)',
    'stategyDetail3': 'Jenis Firmware',
    'stategyDetail4': 'Tingkat baud',
    'stategyDetail5': 'Metode Upgrade',
    'stategyDetail6': 'Kemajuan Upgrade',
    'stategyDetail7': 'Status Polisi',
    'stategyDetail8': 'Waktu awal',
    'stategyDetail9': 'Waktu habis',
    'upgradeList': 'Upgrade Record List',
    'add_strategy': 'Senarai Strategi Upgrade',
    'strategy_time': 'Waktu efektif',
    'strategy_code': 'Kebijakan',
    'strategy_name': 'Name',
    'strategy_desc': 'Deskripsi',
    'strategy_firmware': 'Kemaskini Firmware',
    'strategy_type': 'Jenis',
    'strategy_baudrate': 'Baudrate',
    'uprade_type': 'Metode Upgrade',
    'uprade_name': 'Force',
    'uprade_name1': 'Proposal',
    'uprade_result': 'Upgrade Hasil',
    'uprade_success': 'Pemutakhiran berhasil',
    'uprade_fail': 'Upgrade gagal',
    'uprade_status': 'Status Upgrade',
    'uprade_time': 'Waktu penataran',
    'strategy_number': 'Jumlah',
    'strategy_status': 'Keadaan',
    'start_time': 'Waktu awal',
    'end_time': 'Waktu habis',
    'edit': 'Edit',
    'edit_strategy': 'Sunting Kebijakan',
    'view': 'Check',
    'view_strategy': 'Tampilkan Polisi',
    'cancel': 'Batalkan',
    'cancel_strategy': 'Polisi Batal',
    'force_upgrade': 'Force',
    'suggested_upgrade': 'Proposal',
    'In_effect': 'Dalam efek',
    'expired': 'Mati',
    'Not_started': 'Tidak Dimulai',
    'Not_upgraded': 'Tidak ditambah',
    'Yes_started': 'Ditatar',
    'policy_information': 'Informasi Politik',
    'associated_device': 'Perangkat terhubung',
    'completion_strategy': 'Strategi penyelesaian',
    'upgrade_strategy_list': 'Senarai Strategi Upgrade',
    'Next': 'Derikutnya',
    'TOP': 'Debelumnya',
    'confirm': 'Konfirmasi',
    'go_back': 'Kembali',
    'strategy_detail': 'Strategy Details',
    'strategy_search': 'Kode Polisi/Nama Polisi',
    'strategy_upgrade_search': 'Perangkat SN/Datalogger PN',
    'upgrade_remind': 'Pengingat Upgrade',
    'remind_desc': 'Huraian Pengingatan',
    'default_desc': 'Huraian Default',
    'default_desc1': 'Perangkat ini perlu diubahsuai ke versi yang lebih tinggi sebelum dapat digunakan. Klik pada "Force Upgrade" untuk mengubahsuai. Silakan jangan batalkan koneksi Bluetooth dan pastikan operasi jaringan licin selama upgrade.',
    'message_name': 'Silakan masukkan nama kebijakan',
    'message_desc': 'Silakan masukkan deskripsi kebijakan',
    'message_firmware': 'Silakan pilih peralatan keras',
    'message_type': 'Silakan pilih tipe perangkat keras',
    'message_baudrate': 'Silakan pilih kadar baud',
    'message_timezone': 'Silakan pilih zona waktu',
    'message_time': 'Silakan pilih waktu yang valid',
    'message_uprade_type': 'Silakan pilih tipe penataran',
    'delete_firmware': 'Anda yakin ingin membatalkan kebijakan ini?',
    'delete_desc': 'After cancellation, it will not be possible to recover, and the selected upgrade strategy will not be able to notify the device to upgrade',
    'Upgrade_tip': 'Silakan pilih perangkat yang terkait dengan kebijakan',
    'Upgrade_result': 'Sangat berhasil ditambah',
    'start_date': 'Tanggal efektif',
    'End_date': 'Tarikh kehabisan',
    "limits":     "Tip: the uploaded file must have the data-logger PN in column A; no header row needed—see the example picture below.",
    "mueas":      "Firmware upgrade plan",
    "upNum":      "Total devices to be upgraded",
    "deletCL":    "Delete plan",
    "deletCL_TEST":"Are you sure you want to delete this plan?",
    "ONE_UP":     "Upgrade one device",
    "MO_UP":      "Bulk upgrade devices",
    "MO_text": "Berhasil diimpor",
"MO_tex1": "Duplikat",
"MO_tex3": "Tidak ditemukan",
"MO_tex2": "Organisasi",
"MO_tex4": "Firmware is used in active policy; cannot delete.",
  },
  "cloudsUpgarde": {
    'cloudsFirmware': 'Cloud Upgrade Firmware',
    'cloudsFirmwareList': 'Daftar Upgrade Awan',
  },
  "upgradeManagement": {
    'create': 'Menetapkan',
    'cancel': 'Batalkan',
    'confirm': 'Konfirmasi',
    'upload_firmware': 'Menguasai peralatan keras',
    'edit_firmware': 'Sunting firmware',
    'download_firmware': 'Download firmware',
    'delete_desc': 'Setelah dihapus, tidak akan mungkin untuk pulih, dan strategi penataran yang dipilih untuk perangkat keras ini tidak akan dapat menambah perangkat',
    'eidt_success': 'Success edited',
    'delete_success': 'Dibatalkan dengan sukses',
    'delete_success1': 'Delete success',
    'download_success': 'Download berhasil',
    'firmware_name': 'Nama Paket Firmware',
    'Firmware_Version': 'Nomor versi',
    'please_upgrade': 'Silakan pilih berkas upload',
    'upgrade_success': 'Peralatan firmware yang diunggah dengan sukses',
    'please_input': 'Silakan masukkan',
    'Remarks': 'Deskripsi Firmware',
    'Upload': 'Menguasai peralatan keras',
    'download_firmware_prompt': 'Are you sure you want to download this firmware?',
    'upgrade_file_format': 'Bisa hanya mengunggah dalam format. bin /. hex, tidak dapat melebihi 1MB',
    'upgrade_file_format1': 'Bisa hanya mengunggah dalam format. bin /. hex',
    'upgrade_file_format2': 'Berkas tidak dapat melebihi 1MB',
    'firmwareName_empty': 'Nama Firmware tidak dapat kosong',
    'firmwareVersion_empty': 'Nomor versi tidak dapat kosong',
    "download_exception": "Mengunduh pengecualian, silakan coba lagi nanti",
    "upload_result": "Hasil Unggah",
  },
  // 增
  "project": {
    "choice": "Filter",
    "move": "Bergerak",
    "manageProject": "Manajemen proyek",
    "project": "Proyek",
    "defaultProject": "Default project",
    "projectName": "Nama masukan",
    "projectRemark": "Deskripsi proyek",
    "projectId": "ID Proyek",
    "createProject": "Proyek baru",
    "createResults": "Hasil baru",
    "createSuc": "Baru berhasil",
    "editProject": "Sunting item",
    "editResults": "Sunting hasil",
    "editSuc": "Sunting berhasil",
    "delProject": "Hapus item",
    "delResults": "Hapus hasil",
    "delSuc": "Hapus berhasil",
    "upgradeResults": "Upgrade hasil",
    "upgradeSuc": "Pemutakhiran berhasil",
    "back": "Kembali",
    "placeholder": "Nama perangkat Cari/pn/sn",
    "modifySuc": "Sukses",
    "upload": "Muat naik gambar",
    "limit": "(Ukuran gambar tidak melebihi 1m)",
    "moveTo": "Pindah ke",
    "moveSelect": "Pindahkan yang dipilih",
    "deviceSn": "Peranti SN",
    "tipCard": "Kartu",
    "tipList": "Daftar",
    "tipSearchSN": "Menurut perangkat",
    "tipSearchPN": "Menurut Datalogger",
    "energyCurrent": "Daya saat ini",
    "energyDate": "Generasi daya sehari",
    "energyMonth": "Generasi listrik bulanan",
    "energyYear": "Generasi listrik tahunan",
    "energyTotal": "Total power generation",
  },
  "constant": {
    "renminbi": "RMB (￥)",
    "meiyuan": "USD ($)",
    "ouyuan": "EURO (€)",
    "aoyuan": "AUD ($ A)",
    "yingbang": "GBP (£)",
    "gangbi": "HKD (HK $)",
    "ruidian": "SEK (Kr)",
    "lubi": "RS (Rp)",
    "moxige": "Peso Meksiko (Mex $)",
    "baxi": "Real (R $)",
    "Pakistani": "PKR (Rs)",
    "Rand": "ZAR®",
    "gmt0": "(GMT +00: 00) Waktu Universal Terkoordinasi, Waktu Rata-rata Greenwich, Dublin, Edinburgh, London, Lisbon, Casablanca, Monrovia, Reykjavik",
    "gmt_1": "(GMT +01: 00) Amsterdam, Berlin, Bern, Roma, Stockholm, Wina, Beograd, Bratislava, Budapest, Afrika Tengah Barat, Windhoek",
    "gmt_2": "(GMT + 02: 00) Amman, Beirut, Damaskus, Harare, Pretoria, Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius, Kairo, Minsk, Athena",
    "gmt_3": "(GMT +03: 00) Baghdad, Kuwait, Riyadh, Moskow, St. Petersburg, Volgograd, Nairobi",
    "gmt_4": "(GMT +04: 00) Abu Dhabi, Muscat, Yerevan, Baku, Tbilisi, Waktu Standar Kaukasus, Port Louis",
    "gmt_5": "(GMT +05: 00) Tashkent, Ekaterinburg, Islamabad, Karachi",
    "gmt_55": "(GMT +05: 30) New Delhi",
    "gmt_6": "(GMT +06: 00) Almaty, Novosibirsk, Astana, Dhaka, Novosibirsk",
    "gmt_65": "(GMT +06:30) Myanmar",
    "gmt_7": "(GMT +07: 00) Krasnoyarsk, Bangkok, Hanoi, Jakarta",
    "gmt_8": "(GMT +08: 00) Beijing, Chongqing, Hong Kong, Urumqi, Kuala Lumpur, Singapura, Perth, Taipei, Ulannbaatar, Irkutsk",
    "gmt_9": "(GMT +09: 00) Osaka, Sapporo, Tokyo, Seoul, Yakutsk",
    "gmt_10": "(GMT +10: 00) Brisbane, Vladivostok, Guam, Port Moresby, Hobart, Canberra, Melbourne, Sydney",
    "gmt_11": "(GMT +11: 00) Magadan, Kepulauan Solomon, Kaledonia Baru",
    "gmt_12": "(GMT +12: 00) Auckland, Wellington, Petropavlovsk-Kamchatka-Old, Fiji, Waktu Universal Terkoordinasi + 12",
    "gmt_13": "(GMT +13: 00) Nuku'alofa",
    "gmt_neg_1": "(GMT-01.00) Kepulauan Cape Verde, Azores",
    "gmt_neg_2": "(GMT-02: 00) Atlantik Tengah, Waktu Universal Terkoordinasi-02",
    "gmt_neg_3": "(GMT-03.00) Brasilia, Buenos Aires, Greenland, Cayenne, Fortaleza, Montevideo",
    "gmt_neg_4": "(GMT-04.00) Waktu Atlantik (Kanada), Cuiaba, Georgetown, La Paz, Manaus, San Juan, Santiago, Asuncion",
    "gmt_neg_5": "(GMT-05.00) Waktu Bagian Timur (AS & amp; Kanada), Indiana (Timur), Bogota, Lima, Quito",
    "gmt_neg_6": "(GMT-06.00) Waktu Tengah (AS & amp; Kanada), Guadalajara, Mexico City, Monterrey (lama)",
    "gmt_neg_7": "(GMT-07.00) Chihuahua, La Paz, Mazatlan (lama), Waktu Pegunungan (AS & Kanada), Arizona",
    "gmt_neg_8": "(GMT-08.00) Waktu Pasifik (AS & Kanada), Baja California",
    "gmt_neg_9": "(GMT-09.00) Alaska",
    "gmt_neg_10": "(GMT-10.00) Hawaii",
    "gmt_neg_11": "(GMT-11: 00) Samoa, Waktu Universal Terkoordinasi-11",
    "gmt_neg_12": "(GMT-12.00) Garis Tanggal Internasional Barat",
  },
  "basic": {
    "modifySuc": "Berhasil diubah!",
    "Personal_info": "Informasi pribadi",
    "User_name": "Nama pengguna:",
    "User_name1": "Nama pengguna",
    "Nickname": "Nama panggilan:",
    "Nickname1": "Nama panggilan",
    "editNickname": "Ubah gelaran",
    "Ple_Nickname": "Silakan masukkan nama panggilan",
    "setNickname": "Tetapkan Nickname",
    "Email": "Surel",
    "Email1": "E-mail",
    "Email2": "E-mail：",
    "editEmail": "Ubah email",
    "setEmail1": "Ikat email",
    "Mobile": "nomor telepon：",
    "Mobile1": "nomor telepon",
    "editMobile": "Ubah nomor ponsel",
    "setMobile": "Ikat nomor ponsel",
    "Avatar": "Gambar Pengguna",
    "basic": "Informasi pribadi",
    "Save": "Menyimpan",
    "Select_all": "Kembalikan pilih semua",
    "Ple_phone": "Silakan masukkan telepon untuk diikat",
    "code": "Kode",
    "Ple_code": "Silakan masukkan kode verifikasi",
    "Obtain_code": "Dapatkan Kode",
    "Bind_phone": "Ikat telepon",
    "After_bindingPh": "Kata sandi dapat diambil melalui telepon terikat",
    "Untie_phone": "Lepaskan telepon",
    "Change_phone": "Ganti telepon",
    "Bind_email": "Ikat email",
    "Ple_email": "Silakan masukkan email untuk dijilid",
    "re_enter": "Dapatkan kembali",
    "After_bindingEm": "Kata sandi dapat diambil melalui email terikat",
    "Unbind_email": "Lepaskan email",
    "Change_email": "Ganti e-mail",
    "unbind_Ph": "Apakah Anda yakin untuk melepaskan nomor telepon Anda",
    "unbinding_Ph": "Setelah melepas, Anda tidak akan dapat menggunakan telepon untuk mengambil kata sandi!",
    "unbind_Em": "Apakah Anda yakin untuk melepaskan email tersebut",
    "unbinding_Em": "Setelah melepas ikatan, Anda tidak akan dapat menggunakan email untuk mendapatkan kembali kata sandi!",
    "mobile_code": "Kode verifikasi telah dikirim ke ponsel Anda, silakan periksa",
    "email_code": "Kode verifikasi telah dikirim ke email Anda, silakan periksa",
    "suc_ph": "Berhasil mengikat ponsel",
    "suc_em": "Berhasil mengikat email",
    "code_frequently": "Kode verifikasi sering dikirim, coba lagi nanti",
    "personalCenter": "Pengaturan Akaun",
    "basicInfo": "informasi penting",
    "accountSecurity": "Keamanan rekening",
    "backTo": "kembali",
    "uploadAvatar": "merubah avatar",
    "bindPhone": "Pengikatan ponsel",
    "bindEmail": "Pengikatan Surat",
    "changePwdTip": "Kata sandi dengan keamanan tinggi dapat membuat akun lebih aman.Direkomendasi Anda mengubah kata sandi Anda secara regular dan menetapkan kata sandi 6 ~ 32 digit.",
    "bindPhoneTipBefore": "Telepon terikat：",
    "bindEmailTipBefore": "Ikat kotak surat:",
    "bindPhoneTip": "Atur ponsel untuk log masuk dan mendapatkan sandi Anda,Menerima pemberitahuan dari sistem.",
    "bindEmailTip": "Atur Surat untuk log masuk dan mendapatkan sandi Anda,Menerima pemberitahuan dari sistem.",
    "bindPhoneTipAfter": ",Anda dapat log masuk dan mengambil sandi Anda dan menerima notifikasi yang dikirim oleh sistem.",
    "changeBtn": "ubah",
    "changePwd": "Ubah Sandi",
    "changePwdSuc": "Reset kata sandi berhasil",
    "finished": "selesai",
    "retry": "coba ulang",
    "changeRes": "Hasil modifikasi",
    "bindRes": "Binding results",
    "noHanzi": "Kata sandi tidak dapat mengandung Cina",
    "Nickname_length_tip": "Panjang nama panggilan pengguna 2-32 bit"
  },
  "password": {
    "User_name": "Nama pengguna",
    "Password": "Ubah Kata Sandi",
    "Current_password": "Password lama:",
    "New_password": "kata sandi baru",
    "Config_newpassword": "kata sandi baru",
    "PLCurrent_password": "Silakan masukkan kata sandi lama",
    "PLNew_password": "Silakan masukkan kata sandi baru",
    "PLConfig_newpassword": "Harap konfirmasi kata sandi baru",
    "editPwdSuc": "Kata sandi telah diperbarui!",
    "loginAgain": "Kata sandi berhasil diubah, silakan masuk lagi",
    "Save": "Menyimpan",
  },
  "settingalarm": {
    "chosesstation": "Pilih pembangkit listrik",
    "addEmails": "Tambahkan Email",
    "delete": "Hapus Email berhasil",
    "deletes": "Menghapus",
    "Email_List": "Daftar Email",
    "Add_Mailbox": "Tambahkan Kotak Surat",
    "cancel": "Membatalkan",
    "Add": "Menambahkan",
    "Email_Setting": "Pengaturan Email",
    "Alarm_Type": "Jenis Alarm",
    "Warning": "Peringatan",
    "Error": "Kesalahan",
    "Fault": "Kesalahan",
    "Receiving_Report": "Menerima Laporan",
    "Daily_Report": "Laporan harian",
    "Monthly_Report": "Laporan bulanan",
    "Yearly_Report": "Laporan Tahunan",
    "Receiving_Plant": "Menerima Tanaman:",
    "E_Mail": "Surel：",
    "Email": "Surel",
    "Plant": "Menanam",
    "Operation": "Operasi",
    "Alarm_Typetabel": "Jenis Alarm",
    "Yes": "Iya",
    "No": "Tidak",
    "Delete": "Menghapus",
    "suredelete": "Hapus pemberitahuan email?",
    "Delete_Mailbox": "Hapus Kotak Surat",
    "Add_suc": "Tambahkan E-mail berhasil!",
    "create": "Membuat",
    "list": "jumlah",
    "edit": "Sunting",
  },
  "recharge": {
    "cancel": "membatalkan",
    "early_warning": "Peringatan expirasi kartu aliran",
    "orderno": "Jumlah order",
    "Recharge_tip4": "Rekomendasikan pengguna yang terdaftar untuk PayPal untuk menggunakannya",
    "recharge_type": "tipe",
    "Recharge_tip3": "Direkomendasikan untuk pengguna WeChat yang sudah memasangnya",
    "Recharge1": "Isi ulang aliran",
    "rechargeStatus": "Status isi ulang",
    "Recharge_tip5": "WeChat Pay",
    "openWx": "Silakan buka WeChat ponsel",
    "Hint_language": "Perangkatmu memiliki perangkat 2G. Pada permintaan Kementerian Industri dan Teknologi Informasi, jaringan 2G secara bertahap-hap dihapus. Direkomendasikan untuk membeli dan menggantikan perangkat 4G!",
    "rechMoney": "pembayaran",
    "Recharge": "Isi ulang",
    "Recharge_tip": "Isi Ulang Peringatan",
    "Dead_Time": "Waktu habis",
    "domestic": "domestic",
    "not_for_the_time_being": "Batalkan",
    "Hint_language1": "Jika Anda menghadapi masalah apapun selama proses muatan ulang, silakan hubungi talian panas layanan setelah penjualan di 0755-89993588",
    "rechDiscount": "Diputus",
    "Search": "Cari",
    "warning": "Peringatan dini",
    "Recharge_tip2": "Silakan pilih, misalnya: kapasitas bawaan yang sama adalah 1; Jenis kartu yang sama adalah 4G; Memuatkan ulang bulk untuk kartu data China di daerah yang sama",
    "Recharge_tip1": "Hanya mendukung pemuatan ulang besar kartu jenis yang sama",
    "rechScan": "Silakan buka wechat ponsel untuk menyelesaikan pembayaran",
    "rechTip": "Ingatan: 1. Hanya perangkat dengan tipe kartu yang sama (seperti rumah 4G), kapasitas muatan yang sama, dan status platform penyelamatan kemiskinan yang sama dapat dipilih untuk perintah yang sama (paparan piawai menunjukkan paket dengan kapasitas muatan 1 dan tidak terhubung dengan platform penyelamatan kemiskinan); 2. Memuatkan kembali kartu yang terlambat dan memuat ulang antara tanggal 25 dan tanggal 5 setiap bulan akan menyebabkan terlambat 1-14 hari. Silakan bersabar dan tunggu",
    "Traffic_status": "Status lalu lintas",
    "Status": "Status kartu aliran",
    "DataloggerPN": "PN：",
    "Recharge_money": "Isi Ulang Nilai",
    "Overdue": "Terlambat",
    "Cancel_recharge": "Batalkan muat ulang",
    "Datalogger_List": "Daftar Datalog",
    "Recharged": "Isi Ulang Sukses",
    "Rcharge_Month": "Kali （bulan）",
    "Service_Area": "Area Layanan",
    "Datalogger_PN": "Perangkat PN",
    "rechargeDevice": "Datalogger:",
    "rechargeSucInfo": "Anda telah berhasil membayar dan lalu lintas akan tiba dalam waktu 24 jam",
    "Confirm_recharge": "Konfirmasi ulang muatan",
    "scan": "Sapu pembayarannya",
    "Paid": "Akun Dibayar",
    "Time": "Isi Ulang Waktu",
    "Unpaid": "Tidak Membayar",
    "Operation": "operasi",
    "Connecting_Devices": "dengan nomor beban",
    "Recharge_reminder": "Isi Ulang Peringatan",
    "scanComplete": "Sapu untuk menyelesaikan pembayaran",
    "unknown": "Tidak diketahui",
    "rechargeChannel": "Saluran:",
    "Signal": "Sinyal",
    "Plant": "Nama pembangkit",
    "rechargeDiscount": "Diskon:",
    "expired": "Mati",
    "load": "dengan nomor beban",
    "Recharge_List": "Daftar Isi Ulang",
    "ccid": "CCID",
    "Order_Number": "Jumlah order",
    "Package_type": "Jenis paket",
    "Recharge_record": "Isi ulang ecord",
    "DataloggerName": "Alias",
    "Recharging": "Mengisi ulang",
    "Recharge_Selected": "Isi ulang",
    "rechargeErr": "Pilih pencatat data dengan jumlah muatan yang sama",
    "rechargePrice": "Harga:",
    "abroad": "di luar negeri",
    "normal": "Normal",
    "previous": "Kembali",
    "CCID": "CCID",
    "CCID_time": "Waktu kehabisan kartu aliran",
    "serial_number": "Tidak",
    "Activation_Time": "Waktu Aktivasi",
    "confirm": "Baik",
    "Recharge_status": "Status isi ulang",
    "Recharge_now": "Isi Ulang Sekarang",
    "Content_warning": "Pengguna tersayang! Ditemukan bahwa kartu aliran perangkat yang Anda gunakan akan habis. Jika tidak dimuatkan kembali dalam waktu, kartu aliran akan dibatalkan oleh operator dan tidak dapat terus digunakan. Untuk tidak mempengaruhi penggunaan normal Anda, silakan memuat ulang peralatan dalam status peringatan awal pada waktu!",
    "Recharge_fail": "Pencarian ulang gagal",
    "rechargePackage": "Paket:",
    "rechargeSuc": "Pembayaran berhasil",
    "pn": "Perangkat PN",
    "Tips": "Tips",
    "Recharge_successful": "Isi Ulang Sukses",
    'Recharge_tip6': 'Ada kartu yang tidak mendukung memuat ulang,Silakan hubungi administrator',
    'area_domestic': 'China Mainland',
    'area_abroad': 'internasional',
        'remedy_title': 'Perbaikan pesanan pengisian ulang',
        'upload_tip': 'Pengingat ramah: Format file unggahan adalah .txt'
  },
  "customize": {
    "switchSkin": "Ganti Skin",
    "classic": "Merah Jambu",
    "purple": "Ungu",
    "blue": "Biru",
    "orange": "jeruk",
    "green": "hijau",
  },
  "firmware": {
    "Firmware_limit_format": "Hanya format file .bin, .hex, dan .s19 yang diizinkan",
    "Firmware_upload_fail": "Pengunggahan gagal, silakan coba lagi!",
    "Firmware_upload_failTip": "Unggah Gagal",
    "Firmware_limit1": "Anda dapat mengunggah maksimal",
    "Firmware_limit2": "file",
    "Firmware_limit3": "firmware",
    "Firmware_limitM": "Ukuran file firmware individu tidak boleh melebihi",
    "Firmware_Name": "Nama Firmware",
    "Firmware_desrc": "Deskripsi firmware",
    "Size": "Ukuran (KB)",
    "Upload_Time": "Waktu Unggah",
    "Operation": "Operasi",
    "Firmware_List": "Manajemen Firmware",
    "Firmware_Lists": "Daftar Firmware",
    "Add_Firmware": "Tambahkan Firmware",
    "deleteFirmware": "Menghapus",
    "Firmware_Version": "Nomor versi",
    "editFirmware": "Edit",
    "downloadFirmware": "Download",
    "tips": "Tips",
    "noRecord": "Tidak ada catatan",
    "delete_firmware": "Anda yakin ingin menghapus firmware ini?",
    "cancel": "Membatalkan",
    "confirm": "Konfirmasi",
    "Upload_firmware": "Unggah firmware",
    "Firmware_description": "Deskripsi Firmware",
    "enter_content": "Silakan masukkan isinya",
    "Select_file": "Pilih file",
    "limit": "Hanya file dalam format \".bin\" dan \".hex\" yang dapat diunggah, dan tidak lebih dari 8M yang dapat diunggah",
    "limit0": "Hanya file dalam format \".bin\" dan \".hex\",\".S19\" yang dapat diunggah, dan tidak lebih dari 8M yang dapat diunggah",
    "limit1": "Hanya berkas dalam format \"xlsx\" dapat diunggah",
    "limit2": "Minta ramah: Kolom A dari berkas yang diunggah adalah DataloggerPN, dan kolom B adalah alias Datalogger. Tidak diperlukan judul, seperti yang ditampilkan di bawah.",
    "limit3": "Sangat berhasil ditambah",
    "error1": "Hanya file dalam format \".bin\" dan \".hex\" dan \".S19\"yang dapat diunggah",
        "error2": " Please press LFU button",
    "deleteSuc": "Berhasil dihapus",
    "UploadTitle": "Silakan mengunggah berkas batch",
    "Upload": "Unggah",
    "Upload1": "Menguasai berkas",
    "upgrade_quit1": "Peningkatan tidak normal dan telah dihentikan!",
    "upgrade_quit2": "Upgrade gagal, coba lagi nanti",
    "upgrade_quit3": "pembaruan berhasil",
    "upgrade_quit4": "Upgrade dibatalkan secara manual",
    "upgrade_quit5": "Tidak di upgrade",
    "upgrade_quit6": "Upgrade dibatalkan",
    "upgrade_quit7": "Upgrade gagal",
    "upgrade_quit8": "Tingkatkan pengecualian",
    "upgrading": "perbaikan",
    "upgrading1": "Memutar koneksi, tunggu",
    "updateCompleted": "Pembaruan selesai",
    "CancelUpgradeSuc": "Batalkan upgrade dengan sukses",
    "FailedCancelUpgrade": "Gagal membatalkan peningkatan",
    "del_firmware": "Buang peralatan keras",
    "firmware_upgrade": "Pemutakhiran Firmware",
    "uploadTips": "Silakan mengunggah berkas firmware",
    "CancelUpgradeSuc11": "Pembatalan upgrade berhasil, tunggu sampai kolektor terhubung ke awan sebelum upgrade",
    "upgrade_wait": "Sedang mempersiapkan pembaruan, mohon tunggu 1–2 menit",
    "upgrade_wait1": "Persiapan pembaruan selesai. Harap tunggu hingga datalogger online, lalu mulai ulang tugas pembaruan.",
    "colOffline": "Datalogger tidak online",
		"colUpgrading": "Sedang dalam proses pembaruan",
    "UpgradeStarting": "Pembaruan dimulai, mohon tunggu...",
		"upgradeSq_fail": "Peningkatan datalogger gagal, silakan coba lagi nanti!",
  },
  "browse": {
    'usr': 'Akun bawah',
    'email': 'kotak surat',
    'mobile': 'ponsel',
    'gts': 'Tanggal pendaftaran',
    'desc': 'Catatan',
    'enableStatus': 'Aktifkan Status',
    'Enable': 'Aktifkan',
    'Disable': 'Dilumpuhkan',
    'addBrowse': 'Tambah Akun Sub',
    'pleaseUsr': 'Silakan masukkan akaun bawah',
    'accountInfo': 'informasi akun',
    'username': 'nama pengguna',
    'password': 'sandi',
    'newPassword': 'Kata sandi baru',
    'confirmPassword': 'Konfirmasi Sandi',
    'usrInfo': 'Informasi Pengguna',
    'device': 'Pilihan Proyek',
    'pleaseDevice': 'Pilih Projek',
    'pleaseDevice_title': 'Silakan pilih proyek',
    'pleaseStatus': 'Pilih Status',
    'addSuccess': 'Akaun sub ditambah dengan sukses',
    'editSuccess': 'Sukses edit sub rekening',
    'editBrowse': 'Sunting Akun Sub',
    'deleteSuccess': 'Dihapus dengan sukses',
    'deleteBrowse': 'hapus',
    'delete_browse': 'Apakah Anda yakin untuk menghapus sub rekening?',
    'please_browsepwd': 'Silakan periksa sandi baru dan konfirmasi kebutuhan masukan sandi',
  },
  "retrieve": {
    "Retrieve_password": "Ambil Kata Sandi",
    "Retrieve_passwordPhone": "Kata sandi diterima dengan ponsel",
    "Retrieve_passwordEmail": "Ambil kata sandi dengan email",
    "passwordEmail": "Kotak surat tidak terikat",
    "passwordEmail1": "Kotak surat tidak cocok",
    "passwordPhone": "Nomor ponsel tidak terikat",
    "passwordPhone1": "Nomor ponsel tidak cocok",
    "login": "Gabung",
    "signup": "Daftar",
    "Enter_account": "Masuk Akun",
    "Verify_identidy": "Verifikasi Identidy",
    "reset_Password": "Atur Ulang Kata Sandi",
    "finish": "Selesai",
    "account_password": "Silakan masukkan akun yang Anda butuhkan untuk mendapatkan kembali kata sandi Anda",
    "username": "Nama pengguna",
    "Verification_code": "Kode verifikasi",
    "phone_number": "Nomor telepon",
    "new_password": "kata sandi baru",
    "Con_password": "setujui password",
    "enter_name": "Silakan masukkan nama pengguna",
    "enter_code": "Harap masukkan kode verifikasi",
    "Change_one": "Ubah Satu",
    "confirm": "Konfirmasi",
    "bound_mobile": "Harap masukkan nomor ponsel terikat",
    "Email_verification": "Verifikasi email",
    "Obtain_code": "Dapatkan Kode",
    "code_1minute": "Kode verifikasi telah dikirim ke ponsel Anda dan input valid dalam 1 menit.",
    "Email": "Surel",
    "bound_email": "Silakan masukkan email yang dijilid",
    "Phone_verification": "Verifikasi telepon",
    "code_5minutes": "Kode verifikasi telah dikirim ke email Anda dan entri valid dalam 5 menit.",
    "New_password": "Kata sandi login baru",
    "Confirm_password": "Konfirmasi password baru",
    "Reset_successfully": "Setel ulang berhasil, Harap ingat kata sandi Anda '",
    "re-register": "Daftar ulang",
    "Incorrect_code": "Kode verifikasi salah",
    "email_first": "Silahkan isi email terlebih dahulu",
    "mobile_first": "Silahkan isi nomor handphone terlebih dahulu",
    "Reset_passwordSuc": "Berhasil mengatur ulang kata sandi",
    "Get_codeSucc": "Dapatkan kode verifikasi dengan sukses",
    "Getting_progress": "Sedang dalam proses, Harap tunggu",
    "Newloginpassword": "Kata sandi login baru",
    "Confirmloginpassword": "Konfirmasikan kata sandi login baru",
    "step1": "Langkah1",
    "step2": "Langkah2",
    "step3": "Langkah3",
    "step4": "Langkah4",
  },
  "errCode": {
    "0": "Normal, tidak ada kesalahan",
    "1": "gagal",
    "2": "lembur",
    "3": "Sistem tidak normal. Silakan hubungi administrator",
    "4": "Tanda tangan non-verifikasi",
    "5": "Garam salah dan tidak digunakan sesuai aturan",
    "6": "Kesalahan format parameter",
    "7": "Penolakan platform",
    "8": "Operasi tanpa hak istimewa",
    "9": "Kurangnya parameter yang diperlukan",
    "10": "Autentikasi gagal, harap masuk lagi",
    "11": "Operasi tidak didukung",
    "12": "Tidak ada catatan",
    "13": "Melampaui batas",
    "14": "Operasi berulang",
    "15": "Tidak ada kunci pabrikan",
    "16": "Kegagalan verifikasi kata sandi",
    "17": "Kesalahan format kata sandi",
    "18": "Nomor telepon telah terikat",
    "19": "Kesalahan format nomor telepon",
    "20": "Kesalahan format nama pengguna",
    "21": "Kesalahan format nama pengguna (2 <= Panjang nama pengguna <32)",
    "22": "Kesalahan format nama perusahaan",
    "23": "Kode produsen tidak valid",
    "24": "ulangi nama pengguna",
    "25": "Akun telah dinonaktifkan, harap hubungi administrator",
    "26": "E-mail telah terikat. Silakan ubah e-mail atau nyahikatnya",
    "27": "Akaun telah dibatalkan. Silakan hubungi administrator",
    "256": "Tidak ada catatan",
    "257": "Tidak ada peralatan yang dapat ditemukan",
    "258": "Tidak ada perangkat yang dapat ditemukan",
    "259": "Nomor PN tidak valid, silakan periksa apakah nomor PN benar",
    "260": "Tidak ada tanaman yang dapat ditemukan",
    "261": "Tidak dapat menemukan pengguna",
    "262": "Peralatannya sudah off-line",
    "263": "Pencatat data telah offline",
    "264": "Tidak ada alarm untuk peralatan",
    "265": "Tidak ada detektor lingkungan yang dapat ditemukan",
    "271": "Tidak ada operasi modifikasi",
    "272": "Ulangi penjilidan",
    "273": "Tidak mendukung penambahan penggali untuk pabrikan lain",
    "276": "Itu tidak mendukung pemilik pembangkit listrik yang memiliki perangkat seluler yang berisi pabrikan lain",
    "288": "Tidak dapat menemukan kamera",
    "352": "Tidak ada firmware yang dapat ditemukan",
    "353": "Tidak ada peran yang dapat ditemukan",
    "368": "Tidak ada kesepakatan yang dapat ditemukan",
    "369": "Tidak ada pengelompokan pengguna yang dapat ditemukan",
    "370": "Tidak ada pengelompokan pembangkit listrik yang dapat ditemukan",
    "371": "Tidak ada paket isi ulang lalu lintas GPRS yang dapat ditemukan",
    "372": "Tidak ada urutan pengisian lalu lintas GPRS yang dapat ditemukan",
    "384": "Kesalahan kode verifikasi",
    "385": "Tidak dapat menemukan device_token",
    "386": "Tidak ada informasi konfigurasi perangkat yang dapat ditemukan",
    "387": "Tidak dapat menemukan jenis datalogger",
    "512": "Ketidakcocokan kode otentikasi SMS",
    "513": "Kode verifikasi telah habis waktunya",
    "514": "Nomor telepon / Email tidak cocok",
    "515": "Nomor telepon / Email tidak terikat",
    "516": "Nama tidak boleh sama dengan nama",
    "517": "Ada juga sejumlah datalogger di bawah pengguna atau pembangkit listrik",
    "518": "Pengguna juga memiliki pengguna bawahan",
    "519": "Akun tersebut sudah ada, harap periksa dan isi kembali",
    "520": "Nomor PN duplikat",
    "521": "Penerima bukan milik pengguna",
    "522": "Jumlah datalogger sudah ada",
    "523": "Hanya mendukung pemilik pembangkit listrik",
    "525": "Kode verifikasi telah dikirim, Silakan coba lagi nanti",
    "528": "Peran ini sudah terikat pada pengguna dan tidak dapat dihapus",
    "768": "Tidak ada bidang opsional dalam protokol",
    "772": "Kolektor telah terikat",
    "1024": "Bukan akun browser",
    "1025": "Hanya mendukung dealer",
    "1026": "Hanya produsen peralatan pendukung",
    "1027": "Pengguna yang unggul perlu menjadi distributor atau produsen peralatan",
    "1028": "Jumlah nomor datalogger digital yang berulang",
    "1029": "Isi ulang tidak didukung",
    "1030": "Kartu GPRS tidak valid",
    "1031": "Pengguna tidak dibuat oleh administrator ini",
    "1041": "Kunci gagal atau tidak dapat ditemukan",
    "1042": "CCID tidak valid",
    "1792": "Semua pengumpul data harus milik distributor",
  },
  "controlDeviceErrCode": {
    "1": "Operasi gagal. Silakan periksa perangkatnya dan coba lagi!",
    "2": "Waktu tanggapan habis, tolong coba lagi!",
    "3": "Sistem tidak normal. Silakan hubungi administrator",
    "6": "Galat format #6, silakan hubungi administrator",
    "8": "Menolak #8, silakan hubungi administrator",
    "9": "Operasi #9 tidak didukung, silakan hubungi administrator",
    "11": "Tidak ada izin #11, tolong hubungi administrator",
    "263": "Koleksor data sedang offline. Silakan coba lagi setelah peralatan online!",
  },
  "control":{
		"setting": "Terbitkan",
    "TouSetting": "Mode Kerja Sistem",
    "touCharge": "Prioritas Pengisian",
    "touPersonal": "Konsumsi Sendiri",
    "touComplete": "Umpan Balik Jaringan Penuh",
    "touClipping": "Pemangkasan Puncak dan Pengisian Lembah",
    "touOffgrid": "Aplikasi Off-grid",
    "confirmModeSwitch": "Konfirmasi Perubahan Mode?",
    "modeSwitch": "Ubah Mode",
    "startTime": "Waktu Mulai",
    "endTime": "Waktu Selesai",
    "paramValue": "Silakan Pilih Nilai Parameter",
    "Monday": "Senin",
    "Tuesday": "Selasa",
    "Wednesday": "Rabu",
    "Thursday": "Kamis",
    "Friday": "Jumat",
    "Saturday": "Sabtu",
    "Sunday": "Minggu",
    "syncSetDay": "Terbitkan Sinkron Harian",
    "time": "Periode Waktu 1",
    "time1": "Periode Waktu 2",
    "time2": "Periode Waktu 3",
    "time3": "Periode Waktu 4",
    "time4": "Periode Waktu 5",
    "time5": "Periode Waktu 6",
    "setFail": "Penerbitan Gagal",
    "readFail": "Pembacaan Gagal",
    "charge": "Mengisi Daya",
    "discharge": "Melepaskan Daya",
    "reading": "Berhasil Dibaca",
    "reading_loading": "Sedang Membaca...",
    "pvMode": "Mode Umpan Balik Jaringan",
    "screenshot": "Tangkapan Layar"
	},
  "CollectorCountByOMSOrder": {
    "1": "Operasi gagal",
    "7": "Kehilangan parameter yang diperlukan",
    "8": "Ditolak, tolong hubungi administrator",
    "12": "Tidak ada nomor PN kolektor yang valid di bawah perintah, silakan konfirmasi nomor perintah",
    "23": "Kode manifattur tidak valid. Silakan hubungi administrator",
    "259": "Ada kolektor tidak valid di bawah perintah ini. Silakan hubungi administrator",
    "261": "Tidak dapat menemukan distributor yang ditugaskan, silakan hubungi administrator",
    "772": "Perintah sudah memiliki kolektor terikat. Silakan konfirmasi bahwa kolektor dalam perintah tidak terikat",
  },
  "message": {
    "uname_is_required": "Akun tidak boleh kosong",
    "id_is_required": "Pengelompokan tidak boleh kosong",
    "pwd_is_required": "Kata sandi diperlukan",
    "confpwd_is_required": "Konfirmasi kata sandi tidak dapat kosong",
    "invitation_is_required": "Kode undangan diperlukan",
    "pwdAgain": "Silakan masukkan kata sandi sekali lagi",
    "pwdSame": "Kata sandi lama dan baru tidak boleh sama",
    "oldPass_wrong": "Kata sandi lama salah, harap masukkan kembali",
    "pwdNotsame": "Ketidakkonsistenan kata sandi dua masukan",
    "email_is_required": "Email harus diisi",
    "email_info": "Harap masukkan alamat email yang benar dalam 64 digit",
    "mobile_is_required": "Ponsel diperlukan",
    "pn_is_required": "PN diperlukan",
    "PN_info": "Panjang nomor PN adalah 14 atau 18 digit, dengan huruf pertama menjadi huruf besar dan berisi hanya huruf atas Inggris dan angka",
    "nodata": "Tidak ada data",
    "length2_64": "Panjangnya 2 hingga 64",
    "length2_32": "Panjangnya 2 hingga 32",
    "length6_20": "Hanya 6-20 huruf, angka, garis bawah hanya dapat dimasukkan",
    "length6_32": "Panjangnya 6 hingga 32",
    "delete_plant": "Hapus tanaman",
    "modify_plant": "Ganti tanaman",
    "Exporting_the_report": "Mengekspor laporan",
    "cancel": "Membatalkan",
    "search": "Cari",
    "Logging_off": "Akaun telah dibatalkan, tidak dapat log masuk",
    "country_is_required": "Silakan pilih sebuah negara atau daerah",
  },
  "report": {
    "Export_report": "Ekspor laporan",
    "Subscribe_report": "Tanggalkan laporan",
    "all_reports": "Ekspor semua",
    "Report_type": "Tipe laporan:",
    "Daily_report": "Laporan harian",
    "Monthly_report": "Laporan bulanan",
    "Yearly_Report": "Laporan Tahun",
    "Total_report": "Laporan total",
    "customize": "Sesuaikan",
    "Report_date": "Tanggal laporan:",
    "Report_date1": "Perhatian: The range of export date cannot exceed 31 days",
    "select_date": "Silakan pilih tanggal",
    "to": "Untuk",
    "start_date": "Mulai tanggal",
    "End_date": "Tanggal akhir",
    "cancel": "Membatalkan",
    "Export": "Ekspor",
    "download": "Menunggu untuk diunduh, harap tunggu",
    "Batch_export": "Ekspor batch",
    "current": "saat ini",
    "no_deAlarm": "Tidak ada alarm peralatan terjadi dalam bulan terakhir",
    "Export_alarm": "Ekspor alarm",
  },
  "collectionFrequencyUP": {
    "collect_fast": "Percepatan Pengumpulan Aliran Energi",
    "collect_fast2": "Percepatan aliran energi",
    "collect_fast_fail": "Percepatan gagal, silakan coba lagi",
    "collect_fasting": "Mengakses",
    "collect_fast_starting": "Memulai percepatan",
    "collect_fast1": "Percepatan Pengumpulan Data Rinci",
    "collect_fast1ing": "Data dipercepat",
    "paySecCon": "Konfirmasi Pembayaran",
    "energyFetchPic": "Apakah mengkonfirmasi pengisian daya, kisaran akselerasi pengisian daya sebagai parameter halaman grafik aliran energi seperti di bawah ini",
		"historyFetchPic": "Apakah konfirmasi pengisian, kisaran akselerasi pengisian sebagai parameter halaman rinci data seperti gambar di bawah ini",
		"reRechargeTip1": "Perangkat saat ini telah membeli layanan akselerasi aliran energi. Melanjutkan pembelian akan dikenakan biaya lagi, apakah Anda ingin melanjutkan?",
		"reRechargeTip": "Perangkat saat ini telah membeli layanan akselerasi detail data. Melanjutkan pembelian akan dikenakan biaya lagi, apakah Anda ingin melanjutkan?",
		"continueRecharge": "Lanjutkan Pengisian",
    "collect_fasting_title": "Parameter Waktu Nyata Tidak Disimpan",
    "collect_Order_Record": "Percepatan catatan",
    "Collection_terms": "Terma pemuatan ulang frekuensi koleksi",
    "Recharge_failed_next": "Maaf atas muatan ulang gagal, Anda dapat mencoba membayar lagi",
    "view_order": "Lihat perintah",
    "Once": "detik",
    "every_interval": "Spesifikasi akselerasi yang dipilih saat ini adalah: setiap interval",
    "Collect_terms2": "1[UNK] Ambang aplikasi paket",
    "Collect_terms3": "Parameter paparan yang termasuk dalam protokol yang digunakan oleh kolektor untuk memuat ulang Anda (catatan: jika Anda memilih halaman Graf Aliran Energi untuk memuat ulang dipercepat, skop paket tersebut terbatas ke julat parameter paparan halaman Graf Aliran Energi; jika Anda memilih halaman Data Sejarah untuk memuat ulang dipercepat, skop paket tersebut terbatas ke julat parameter paparan halaman Data Sejarah)",
    "Collect_terms4": "2[UNK] Tidak mendukung penggantian protokol/perangkat",
    "have_read": "Saya telah membacanya dengan teliti",
    "Collect_terms5": "Mengubah protokol/perangkat tidak berpartisipasi dalam kesenangan akselerasi",
    "Collect_terms6": "3[UNK] Batalkan paket",
    "Collect_terms": "Kumpulkan terma muat ulang yang dipercepat",
    "View_Details": "Lihat Rincian",
    "Recharge_result": "Ulangi hasil",
    "Collect_terms7": "Batalkan subscribe dan perubahan tidak didukung setelah pembayaran",
    "Online_payment": "Pembayaran online",
    "Collect_terms8": "4[UNK] Harga paket",
    "Collect_terms9": "Our fees are calculated based on your parameter quantity, accelerated collection frequency, and load capacity, and the final price is determined accordingly; Selain kondisi di atas, data sejarah juga melibatkan waktu penyimpanan",
    "acquisition_frequency": "Frekuensi koleksi",
    "Recharge_failed": "Pencarian ulang gagal",
    "Recharge_amount": "Isi Ulang Nilai",
    "Scan_payment": "Pembayaran kode imbas",
    "collect_recharge": "Pengisian Ulang Akselerasi Pengumpulan (Percepatan Pengumpulan Data Rinci)",
    "collect_recharge1": "Pengisian Ulang Akselerasi Pengumpulan (Percepatan Aliran Energi)",
    "Collect_terms10": "5[UNK] Konsum lalu lintas",
    "Purchase_Terms7": "Ada pertanyaan lain",
    "Purchase_Terms8": "Jika Anda memiliki pertanyaan lain, Anda dapat menghubungi layanan pelanggan online kami untuk konsultasi, dan kami akan memberikan jawaban terperinci",
    "Collect_terms11": "Mengecelerasi frekuensi koleksi akan memperburuk konsumsi lalu lintas",
    "Purchase_Terms6": "Our fees are calculated based on your parameter quantity, accelerated collection frequency, and load capacity, and the final price is determined accordingly; Selain kondisi di atas, data sejarah juga melibatkan waktu penyimpanan",
    "Purchase_Terms5": "Harga Paket",
    "Purchase_Terms4": "Silakan tunggu versi baru kami. Versi saat ini hanya mendukung mengumpulkan dan meningkatkan semua parameter paparan. Kami minta maaf atas ketidaknyamanan yang disebabkan!",
    "Purchase_Terms3": "Tidak bisakah saya mengubah frekuensi koleksi untuk beberapa parameter",
    "Real_parameters": "Real time parameters",
		"Purchase_Terms1": "Masa Berlaku Akselerasi Pengumpulan",
		"Purchase_Terms2": "Waktu kedaluwarsa layanan akselerasi pengumpulan akan dihitung secara otomatis berdasarkan durasi paket yang Anda beli. Waktu kedaluwarsa spesifik mengacu pada tampilan halaman",
    "device_Info": "Informasi peralatan",
    "Recharge_successful_next": "Selamat atas pencarian ulang sukses Anda. Kami akan meningkatkan frekuensi koleksi Anda, dan Anda dapat mengikuti perubahan frekuensi koleksi Anda mulai sekarang",
    "Purchase_Terms": "Terma Pembelian",
    "gather": "koleksi",
    "Recharge_time": "Isi Ulang Waktu",
    "Payment_method": "Syarat pembayaran",
    "Type": "Jenis pengisian",
    "Recharge_now": "Isi Ulang Sekarang",
    "History_Data": "data sejarah",
    "Collect_terms1": "Terma layanan akselerasi frekuensi koleksi",
    "Package": "Paket Percepatan",
    "PN_order": "Nomor perintah/PN",
    "Order_No": "Jumlah order",
    "Recharge_successful": "Isi Ulang Sukses",
    "noRecharg": "Kolektor tidak mendukung memuat ulang",
    "noRecharg_min": "Kecepatan koleksi Anda telah mencapai yang paling cepat!",
    "noRecharg_wifi": "Versi saat ini hanya mendukung akuisisi data modul Wi-Fi",
    "paypalTip": "Jumlah pembayaran akhir berdasarkan PayPal",
    "upPrice": "Perbedaan harga",
  },
  alarmNew: {
    'fileName': 'Nama File',
    'fileSize': 'Ukuran File',
    'fileStatus': 'Status File',
    'progress': 'Progress',
    'can': 'Dapat Diunduh',
    'no': 'Sedang Diekspor',
    'history': 'Riwayat Ekspor'
  },
  	shuoriExport:{
    "exportRecords": "Exportaufzeichnungen",
    "export": "Exportieren",
    "exportTask": "Exportaufgabe wurde erstellt. Bitte laden Sie die Datei später unter „Exportaufzeichnungen“ herunter.",
    "noDownload": "Die Datei-URL ist ungültig oder kann nicht heruntergeladen werden. Bitte versuchen Sie es erneut.",
    'data': 'Tanggal',
	},
  	colUnBindRecord: {
    'UnBindRecord': 'Catatan Pembatalan Pengikatan Datalogger',
    "unStatus": "Status Pembatalan Ikatan",
    "unScene": "Skenario Pembatalan Ikatan",
    "oldUser": "Pengguna Asli",
    "newUser": "Pengguna Baru",
    "unCount": "Jumlah Pembatalan Ikatan",
    "pnBarCode": "Barcode Nomor Komponen",
    "devicePicture": "Foto Perangkat Fisik",
    "ip": "IP yang Dibatalkan",
    "unTime": "Waktu Pembatalan Ikatan"
	},
  	rosRecharge: {
		'electronicInvoicing': 'Faktur Elektronik',
		'issueEInvoice': 'Buat Faktur Elektronik',
		'invoiceHistory': 'Riwayat Faktur',
		'rechargeDuration': 'Durasi Pengisian',
		'year': 'Tahun',
		'month': 'Bulan',
		'day': 'Hari',
		'days': 'Hari',
		'pendingPayment': 'Menunggu Pembayaran',
		'paymentSuccess': 'Pembayaran Berhasil',
		'paymentFailed': 'Pembayaran Gagal',
		'orderClosed': 'Pesanan Ditutup',
		'serviceTerminated': 'Layanan Dihentikan',
		'unpaid': 'Belum Dibayar',
		'paying': 'Sedang Membayar',
		'paid': 'Sudah Dibayar',
		'refunded': 'Sudah Dikembalikan',
		'cancelled': 'Dibatalkan',
		'rechargeSuccess': 'Pengisian Berhasil',
		'rechargeFailed': 'Pengisian Gagal',
		'pleaseSelectDate': 'Silakan pilih tanggal',
		'orderNo': 'Nomor Pesanan',
		'batchInvoicing': 'Faktur Massal',
		'rechargeType': 'Jenis Pengisian',
		'trafficRecharge': 'Pengisian Lalu Lintas',
		'collectRecharge': 'Pengisian Pengumpulan',
		'rechargeStatus': 'Status Pengisian',
		'invoice': 'Faktur',
		'invoiceStatus': 'Status Faktur',
		'invoiceTime': 'Waktu Faktur',
		'viewDetail': 'Lihat Detail',
		'invoicing': 'Sedang Membuat Faktur',
		'invoiceSuccess': 'Faktur Berhasil',
		'invoiceFailed': 'Faktur Gagal',
		'issueElectronicInvoice': 'Buat Faktur Elektronik',
		'invoiceType': 'Jenis Faktur',
		'generalInvoice': 'Faktur Umum',
		'specialInvoice': 'Faktur Khusus (PPN)',
		'headerType': 'Jenis Kop',
		'companyHeader': 'Kop Perusahaan',
		'personalHeader': 'Kop Pribadi/Non-perusahaan',
		'pleaseInputCompanyHeader': 'Silakan masukkan kop perusahaan',
		'taxNumber': 'Nomor Pajak',
		'pleaseInputTaxNumber': 'Silakan masukkan nomor identifikasi wajib pajak',
		'headerName': 'Nama Kop',
		'suggestPersonalName': 'Disarankan mengisi nama pribadi/nama toko',
		'invoiceContent': 'Isi Faktur',
		'internetCommService': 'Layanan Komunikasi Internet',
		'invoiceAmount': 'Jumlah Faktur',
		'yuan': 'CNY',
		'moreInfo': 'Informasi Lebih Lanjut',
		'remarkAddressEtc': 'Catatan, alamat, dll.',
		'companyAddress': 'Alamat Perusahaan',
		'pleaseInputCompanyAddress': 'Silakan masukkan alamat perusahaan',
		'companyPhone': 'Telepon Perusahaan',
		'pleaseInputCompanyPhone': 'Silakan masukkan telepon perusahaan',
		'openingBank': 'Bank Pembuka Rekening',
		'pleaseInputOpeningBank': 'Silakan masukkan bank pembuka rekening',
		'bankAccount': 'Nomor Rekening Bank',
		'pleaseInputBankAccount': 'Silakan masukkan nomor rekening bank',
		'remark': 'Catatan',
		'pleaseInputRemark': 'Silakan masukkan catatan',
		'email': 'Email',
		'pleaseInputEmail': 'Silakan masukkan alamat email',
		'cancel': 'Batal',
		'submit': 'Kirim',
		'invoiceResult': 'Hasil Faktur',
		'invoiceSubmitted': 'Permohonan faktur telah dikirim',
		'invoiceExpectedTip': 'Faktur diperkirakan akan diterbitkan dalam 48 jam, silakan periksa',
		'viewInvoiceStatus': 'Lihat Status Faktur',
		'pleaseInputHeaderName': 'Silakan masukkan nama kop',
		'pleaseInputValidEmail': 'Silakan masukkan alamat email yang valid',
		'invoiceApplyFailed': 'Permohonan faktur gagal',
		'viewInvoice': 'Lihat Faktur',
		'downloadPdf': 'Unduh PDF',
		'manualService': 'Layanan Manual',
		'invoiceSentToEmail': 'Informasi faktur telah dikirim ke email Anda, silakan periksa',
		'pleaseWaitInvoicing': 'Harap tunggu dengan sabar hingga faktur selesai',
		'pleaseContactManual': 'Silakan hubungi layanan manual untuk membuat faktur',
		'noPdfAvailable': 'Tidak ada file PDF yang tersedia untuk diunduh',
		'serviceUnavailable': 'Layanan pelanggan saat ini tidak tersedia',

	}
};
export default om;
